<template>
  <div>

    <vs-row vs-w="12" class="mb-2">
      <vs-col
        vs-type="flex"
        vs-justify="left"
        vs-align="left"
        vs-lg="4"
        vs-sm="4"
        vs-xs="12"
      >
      <h5>
        {{
          campaignDescription ? 'Campaign : ' + campaignDescription.campaign_name + ' ' + campaignDescription.campaign_code : null
        }}
      </h5>
     
      </vs-col>
      <vs-col
        vs-type="flex"
        vs-justify="center"
        vs-align="center"
        vs-lg="4"
        vs-sm="4"
        vs-xs="12"
      >
       
      </vs-col>
      <vs-col
        vs-type="flex"
        vs-justify="right"
        vs-align="right"
        vs-lg="4"
        vs-sm="4"
        vs-xs="12"
      >

      </vs-col>
    </vs-row>
   

    <div>
      <div class="vx-col w-full">
        <vs-row
          :class="{
            'blur-content':
              AuditTrialPopupActive || AuditTrialWithDialPopupActive
          }"
          class="pb-1"
        >
          <vx-card>
            <vs-col vs-type="flex" vs-w="1">
              <h5>Menu</h5>
            </vs-col>
            <vs-col vs-w="1" class="mb-1">
              <vs-button size="small" type="flat" @click="addAccountTags"
                >Account Tags</vs-button
              >
            </vs-col>
            <vs-col vs-type="flex" vs-w="1" class="mb-1">
              <vs-button size="small" type="flat" @click="addContactTags"
                >Contact Tags</vs-button
              >
            </vs-col>
            <vs-col vs-type="flex" vs-w="1" class="mb-1">
              <vs-button size="small" type="flat" @click="addAccountStatus"
                >Account Status</vs-button
              >
            </vs-col>
            <vs-col vs-type="flex" vs-w="1" class="mb-1">
              <vs-button size="small" type="flat" @click="addContactStatus"
                >Contact Status</vs-button
              >
            </vs-col>
            <vs-col vs-type="flex" vs-w="1" class="mb-1">
              <vs-button size="small" type="flat" @click="saveViewPopup"
                >Save View</vs-button
              >
            </vs-col>
            <vs-col vs-type="flex" vs-w="1" class="mb-1">
              <vs-button size="small" type="flat" @click="viewOpportunities"
                >Opportunities</vs-button
              >
            </vs-col>
            <vs-col vs-type="flex" vs-w="1" class="mb-1">
              <vs-button size="small" type="flat" @click="GradeChangedFilterView"
                >Date Range</vs-button
              >
            </vs-col>

            <vs-col vs-type="flex" vs-w="1" class="mb-1">
              <vs-button size="small" type="flat" @click="AuditTrialChangedFilterView"
                >Called Records</vs-button
              >
            </vs-col>

            <vs-col vs-type="flex" vs-w="1" class="mb-1">
              <vs-button size="small" type="flat" @click="requestAccount"
                >Request Accounts</vs-button
              >
            </vs-col>

            <vs-col vs-type="flex" vs-w="2" class="mb-2">
              <span class="mt-3 mr-5">Select:</span>

              <v-select
                style="width: 100%"
                v-model="selected_view_for_sd"
                label="name"
                :options="sd_view_options"
                name="sd_view"
              />
            </vs-col>
          </vx-card>
        </vs-row>

        <vs-row
          :class="{
            'blur-content':
              AuditTrialPopupActive || AuditTrialWithDialPopupActive
          }"
          vs-w="12"
          class="mt-2"
        >
          <vs-col vs-type="flex" vs-lg="3" vs-sm="12" vs-xs="12">
            <vx-card :title="'Accounts : ' + no_of_campaign_accounts " class="mr-3">
              <!-- <vs-icon icon="refresh" size="small" 
              ></vs-icon> -->

              <div class="agrid-scroll">
                <div class="text-center" v-if="showAccountTagFilterOption">
                  <ul class="mb-2">
                    <li v-for="v in all_account_tags" class="p-1">
                      <vs-checkbox
                        v-model="selected_filter_account_tag"
                        :vs-value="v.id"
                        >{{ v.tag }}</vs-checkbox
                      >
                    </li>
                  </ul>
                </div>
                <SDAccountDataGrid
                  :context="'SDQCAccount'"
                  @showStatusPopUp="showAccountStatusPopUp"
                  @showTagPopUp="showAccountTagPopUp"
                  ref="SDQCAccount"
                  :columnDefs="accountColumnDefs"
                  :rowData="accountRecords"
                  @showContactsWithAccountID="showContactsWithAccountID"
                  @editSalesDeveloperAccount="editSalesDeveloperAccount"
                  :rowSelection="'single'"
                >
                  <template v-slot:refresh-button>
                    <vs-icon
                      @click="refreshSDAccount"
                      size="small"
                      color="dark"
                      icon="refresh"
                    ></vs-icon>
                  </template>

                  <template v-slot:sort-button>
                    <h6>Tag</h6>
                    <vs-icon
                      class="mr-2 tag-filter"
                      @click="showAccountTagFilter"
                      size="small"
                      color="dark"
                      icon="sort"
                    ></vs-icon>
                  </template>
                </SDAccountDataGrid>
              </div>
              <div class="p-5"></div>
              <h4 v-if="selected_account_id">Account Fields</h4>
              <ClientDataGrid
              ref="SDQCAccountFieldRef"
              :columnDefs="accountSDQCAccountFields"
              :rowData="getSDAccountSelectedFieldRecords"
              :rowSelection="'single'"
              v-if="selected_account_id"
            >
            </ClientDataGrid>


              <!-- <DataGrid
                :context="'SDQCAccountFieldRef'"
                @onSDQCAccountFilterModified="onSDQCAccountFilterModified"
                v-if="selected_account_id"
                ref="SDQCAccountFieldRef"
                :columnDefs="accountSDQCAccountFields"
                :dataSource="getSDAccountSelectedDataSource"
              >
              </DataGrid> -->
            </vx-card>
          </vs-col>
          <vs-col vs-type="flex" vs-lg="7" vs-sm="12" vs-xs="12">
              <vx-card :title="'Contacts : ' + no_of_campaign_contacts " class="mr-3">

              <div class="agrid-scroll">
                <div class="text-center" v-if="showContactTagFilterOption">
                  <ul class="mb-2">
                    <li v-for="v in all_contact_tags" class="p-1">
                      <vs-checkbox
                        v-model="selected_filter_contact_tag"
                        :vs-value="v.id"
                        >{{ v.tag }}</vs-checkbox
                      >
                    </li>
                  </ul>
                </div>
                <DataGrid
                  :context="'SDQCContact'"
                  @showStatusPopUp="showContactStatusPopUp"
                  @showTagPopUp="showContactTagPopUp"
                  @showSalesDeveloperAuditTrial="showSalesDeveloperAuditTrial"
                  @dialNumber="dialNumber"
                  @showDialPopup="showDialPopup"
                  @editSalesDeveloperContact="editSalesDeveloperContact"
                  @onSDQCAccountFilterModified="onSDQCAccountFilterModified"
                  ref="SDQCContact"
                  :columnDefs="contactsColumnDefs"
                  :dataSource="contactDataSource"
                  :rowSelection="'single'"
                  @onPaginationChangeContact="onPaginationChangeContact"
                  @showContactsFieldsWithContactID="
                    showContactsFieldsWithContactID
                  "
                >
                  <template v-slot:refresh-button>
                    <vs-icon
                      @click="refreshSDContact"
                      color="dark"
                      size="small"
                      class="mr-10"
                      icon="refresh"
                    ></vs-icon>
                  </template>
                  <template v-slot:sort-button>
                    <h6>Tag</h6>
                    <vs-icon
                      class="mr-2 tag-filter"
                      @click="showContactTagFilter"
                      size="small"
                      color="dark"
                      icon="sort"
                    ></vs-icon>
                  </template>
                </DataGrid>
              </div>
              <div class="p-5"></div>

              <h4 v-if="selected_contact_id">Contact Fields</h4>


              <ClientDataGrid
              ref="SDQCContactFieldRef"
              :columnDefs="contactSDQCContactFields"
              :rowData="getSDContactSelectedFieldRecords"
              :rowSelection="'single'"
              v-if="selected_contact_id"
            >
            </ClientDataGrid>


<!-- 
              <DataGrid
                :context="'SDQCContactFieldRef'"
                v-if="selected_contact_id"
                ref="SDQCContactFieldRef"
                :columnDefs="contactSDQCContactFields"
                :dataSource="getSDContactSelectedDataSource"
              >
              </DataGrid> -->
            </vx-card>
          </vs-col>
          <vs-col vs-type="flex" vs-lg="2" vs-sm="12" vs-xs="12">
            <vx-card title="Notes">
              <!-- <p>
              An External Link Summary component can be used to prominently
              feature a link to an external website (another YSM website or
              anywhere else on the web) with a short text introduction and link.
              Like regular "Content" schema summaries, External Link Summaries
              are compatible with any summary or summary grid component
              template.You can use an External Link Summary component to feature
              a prominent link to an external website (another YSM website or
              anywhere else on the web) with a short text introduction and link.
              Like regular "Content" schema summaries, External Link Summaries
              are compatible with any summary or summary grid component
              template.
            </p> -->

              <p v-if="accountNotes">
                {{ accountNotes.notes }}
              </p>
              <p v-if="contactNotes">
                {{ contactNotes.summary }}
              </p>

              <vs-divider />
              <div class="audit_trial_style">
                <h4 class="mb-5">Audit Trial - Attempts: {{ dial_counts }}</h4>

                <!-- {{contactsAuditTrials}} -->
                <template v-for="cat in contactsAuditTrials">
                  <div class="mb-2">
                    <h6 class="mb-1">Action Type</h6>
                    <p>
                      {{ cat.action_type }}
                    </p>
                  </div>

                  <div class="mb-2">
                    <h6 class="mb-1">Outcome</h6>
                    <p>
                      {{ cat.outcome }}
                    </p>
                  </div>

                  <div class="mb-2">
                    <h6 class="mb-1">Sales Developer</h6>
                    <p>
                      {{ cat.sales_developer }}
                    </p>
                  </div>

                  <div class="mb-2">
                    <h6 class="mb-1">Date/Time</h6>
                    <p>
                      {{ cat.date_time }}
                    </p>
                  </div>

                  <div class="mb-2">
                    <h6 class="mb-1">Notes</h6>
                    <p>
                      {{ cat.notes }}
                    </p>
                  </div>

                  <vs-divider class="p-2" />
                </template>
              </div>
            </vx-card>
          </vs-col>
        </vs-row>
        <dialog-drag
          :title="'Add Audit Trial'"
          id="dialogBox"
          @load="loadContent"
          :options="vueDraggablePopUpOptions"
          @close="closeAuditTrialPopupActive"
          v-if="AuditTrialPopupActive"
        >

        <!-- <div class="text-center">
          <h6 class="mb-5"> {{ selected_contact_aggrid_node.data._ec41e532_632d_4323_8071_f60b4543a68a + ' - ' + selected_contact_aggrid_node.data._78540c9c_ce81_4ec0_8320_31838956392a + ' ' + selected_contact_aggrid_node.data._755c8e1e_1725_4653_93f6_b8a888f4a423 }}</h6>
         </div> -->
          <h5>
            <vs-row v-if="!auditTrialWithDial">
              <div class="vx-row w-full mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                  <span>Date/Time:</span>
                </div>
                <div class="vx-col sm:w-1/2 w-full">
                  <flat-pickr
                    :config="configDateAndTimePicker"
                    placeholder="Choose Date And Time"
                    name="audit_date_time"
                    v-model="audit_trial.date_time"
                  />
                </div>
              </div>

              <div class="vx-row w-full mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                  <span>Action Type:</span>
                </div>
                <div class="vx-col sm:w-1/2 w-full">
                  <v-select
                    label="name"
                    name="action_type"
                    :options="action_types"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    v-model="audit_trial.action_type"
                    v-validate="'required'"
                    data-vv-as="Action Type"
                  />
                  <!-- <span class="text-danger text-sm mt-2" v-show="errors.has('action_type')">{{ errors.first("action_type")
                }}</span> -->
                </div>
              </div>
              <div class="vx-row w-full mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                  <span>Outcome:</span>
                </div>
                <div class="vx-col sm:w-1/2 w-full">
                  <v-select
                    label="name"
                    name="outcome"
                    :options="outcomes"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    v-model="audit_trial.outcome"
                    v-validate="'required'"
                    data-vv-as="Outcome"
                  />
                  <!-- <span class="text-danger text-sm mt-2" v-show="errors.has('outcome')">{{ errors.first("outcome")
                }}</span> -->
                </div>
              </div>

              <div class="vx-row w-full mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                  <span>Notes:</span>
                </div>
                <div class="vx-col sm:w-1/2 w-full">
                  <vs-textarea
                    class="w-full mb-2"
                    name="notes"
                    v-model="audit_trial.notes"
                  />
                </div>
              </div>

              <div
                class="vx-row w-full mb-6"
                v-if="selected_options.length != 0"
              >
                <div class="vx-col sm:w-1/3 w-full"></div>
                <div class="vx-col sm:w-1/2 w-full">
                  <vs-button
                    v-if="selected_options.includes('submit')"
                    class="mr-3 mb-2"
                    @click.prevent="submitAuditTrialForm"
                    >Submit</vs-button
                  >
                  <vs-button
                    v-if="selected_options.includes('schedule_a_next_action')"
                    class="mr-3 mb-2"
                    @click.prevent="addScheduleANextAction"
                    >Schedule a Next Action</vs-button
                  >
                  <vs-button
                    v-if="
                      selected_options.includes(
                        'no_i_dont_to_schedule_a_next_action'
                      )
                    "
                    class="mr-3 mb-2"
                    @click.prevent="noIdontToScheduleANextAction"
                    >No, I don't want to schedule a next action</vs-button
                  >
                  <vs-button
                    v-if="selected_options.includes('next')"
                    class="mr-3 mb-2"
                    @click.prevent="dialNext"
                    >Next
                  </vs-button>
                </div>
              </div>
            </vs-row>
          </h5>
        </dialog-drag>
        <vs-popup :title="showDialTitle" :active.sync="dialPopupActive">
          <h5>
            <vs-row>
              <vs-col
                class="p-2"
                v-if="!showEditNumbers"
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                vs-w="12"
                v-for="numbers in listofNumbers"
                v-bind:key="numbers.id"
              >
                <div v-if="showDialTitle == 'ddi'">
                  <vs-row vs-w="12">
                    <vs-col
                      vs-type="flex"
                      vs-justify="center"
                      vs-align="center"
                      vs-lg="12"
                      vs-sm="4"
                      vs-xs="12"
                    >
                      <u>
                        <a
                          @click="auditTrialWithDialFunc(numbers)"
                          :href="'sip:' + numbers.ddi_phone_code + numbers.ddi"
                        >
                          {{ numbers.ddi_phone_code }}{{ numbers.ddi }}</a
                        >
                      </u>

                      <vs-icon
                        class="ml-5"
                        v-if="numbers.is_primary"
                        icon="loyalty"
                        size="small"
                        >ⓟ</vs-icon
                      >
                      <vs-icon
                        class="ml-5"
                        v-if="numbers.checked_status == 'Registered'"
                        icon="loyalty"
                        size="small"
                        >®</vs-icon
                      >
                    </vs-col>
                  </vs-row>
                </div>
                <div v-if="showDialTitle == 'mobile'">
                  <vs-row vs-w="12">
                    <vs-col
                      vs-type="flex"
                      vs-justify="center"
                      vs-align="center"
                      vs-lg="12"
                      vs-sm="4"
                      vs-xs="12"
                    >
                      <u>
                        <a
                          @click="auditTrialWithDialFunc(numbers)"
                          :href="
                            'sip:' + numbers.mobile_phone_code + numbers.mobile
                          "
                        >
                          {{ numbers.mobile_phone_code }}{{ numbers.mobile }}</a
                        >
                      </u>

                      <vs-icon
                        class="ml-5"
                        v-if="numbers.is_primary"
                        icon="loyalty"
                        size="small"
                        >ⓟ</vs-icon
                      >
                      <vs-icon
                        class="ml-5"
                        v-if="numbers.checked_status == 'Registered'"
                        icon="loyalty"
                        size="small"
                        >®</vs-icon
                      >
                    </vs-col>
                  </vs-row>
                </div>
                <div v-if="showDialTitle == 'other'">
                  {{ numbers.phone_type }} :

                  <u>
                    <a
                      @click="auditTrialWithDialFunc(numbers)"
                      :href="'sip:' + numbers.phone_code + numbers.phone_no"
                    >
                      {{ numbers.phone_code }}{{ numbers.phone_no }}</a
                    ></u
                  >
                  <vs-icon
                    class="ml-5"
                    v-if="numbers.is_primary"
                    icon="loyalty"
                    size="small"
                    >ⓟ</vs-icon
                  >
                </div>
              </vs-col>
              <vs-col
                class="p-2"
                v-if="showEditNumbers"
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                vs-w="12"
                v-for="numbers in listofNumbers"
                v-bind:key="numbers.id"
              >
                <v-select
                  v-if="showDialTitle == 'ddi'"
                  name="phone_code"
                  class="phone_code"
                  label="name_with_code"
                  :options="all_phone_codes"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  v-model="numbers.ddi_phone_code"
                />

                <vs-input
                  v-if="showDialTitle == 'ddi'"
                  class="w-full mr-5"
                  name="ddi"
                  v-model="numbers.ddi"
                />
                <vs-radio
                  v-if="showDialTitle == 'ddi'"
                  v-model="primary_ddi"
                  :vs-value="numbers.ddi"
                  class="mr-4"
                  vs-name="primary_email"
                ></vs-radio>

                <v-select
                  v-if="showDialTitle == 'mobile'"
                  name="phone_code"
                  class="phone_code"
                  label="name_with_code"
                  :options="all_phone_codes"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  v-model="numbers.mobile_phone_code"
                />
                <vs-input
                  v-if="showDialTitle == 'mobile'"
                  class="w-full mr-5"
                  name="mobile"
                  v-model="numbers.mobile"
                />

                <vs-row>
                  <vs-col
                    vs-type="flex"
                    vs-justify="center"
                    vs-align="center"
                    vs-lg="4"
                    vs-sm="4"
                    vs-xs="12"
                  >
                    <v-select
                      v-if="showDialTitle == 'other'"
                      name="phone_code"
                      class="phone_code"
                      label="name_with_code"
                      :options="all_phone_codes"
                      :dir="$vs.rtl ? 'rtl' : 'ltr'"
                      v-model="numbers.phone_code"
                    />
                  </vs-col>
                  <vs-col
                    vs-type="flex"
                    vs-justify="center"
                    vs-align="center"
                    vs-lg="4"
                    vs-sm="4"
                    vs-xs="12"
                  >
                    <vs-input
                      v-if="showDialTitle == 'other'"
                      class="w-full"
                      name="other"
                      v-model="numbers.phone_no"
                    />
                  </vs-col>
                  <vs-col
                    vs-type="flex"
                    vs-justify="center"
                    vs-align="center"
                    vs-lg="4"
                    vs-sm="4"
                    vs-xs="12"
                  >
                    <v-select
                      label="slug"
                      v-if="showDialTitle == 'other'"
                      :options="phoneTypes"
                      :dir="$vs.rtl ? 'rtl' : 'ltr'"
                      v-model="numbers.phone_type"
                    />
                  </vs-col>
                </vs-row>

                <vs-radio
                  v-if="showDialTitle == 'mobile'"
                  v-model="primary_mobile"
                  :vs-value="numbers.mobile"
                  class="mr-4"
                  vs-name="primary_mobile"
                ></vs-radio>
              </vs-col>
              <vs-col
                class="p-2"
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                vs-w="12"
              >
                <vs-button
                  v-if="showEditNumbers"
                  @click="updateQCNumbers"
                  color="primary"
                  type="filled"
                  >Update
                </vs-button>

                <vs-button
                  v-if="!showEditNumbers"
                  @click="editNumbers"
                  color="primary"
                  type="filled"
                  >Edit</vs-button
                >
              </vs-col>
            </vs-row>
          </h5>
        </vs-popup>
        <vs-popup
        :title="'Edit Account'"
        fullscreen
        :active.sync="editSDAccountPopUp"
      >

       

            <vs-button class="mb-5"
                  @click="requestContact(selectedEditAccountId)"
                  color="primary"
                  type="filled"
                  >Request Contact</vs-button
                >



        <template v-for="(value,key) in all_field_datas">
      

          <template v-for="field_array_column in  all_field_datas['campaign_data_options']">

        


             <template v-if="field_array_column.column_id == key && field_array_column.identifier != 'phone_type' && field_array_column.identifier != 'phone_code'">


  
              <div class="vx-row mb-6">

                <div class="vx-col sm:w-1/5 w-full">

                  <template v-if="field_array_column.identifier != 'switchboard_phone_code'">
                    <span>{{ field_array_column.name }} </span>

                  </template>
                  <!-- {{ field_array_column.column_id }} -->
                </div>
               
                <div class="vx-col sm:w-2/3 w-full">
                  <div class="vx-col sm:w-2/3 w-full">

                    <!-- {{field_array_column}} -->
  
  
                   <template v-if="field_array_column.identifier == 'registered_office_country'">
  
                    <v-select name="registered_office_country" class="registered_office_country" label="name_1"
                    :options="all_countries" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="all_field_datas[key]" />
                   </template>

                     <template v-else-if="field_array_column.identifier == 'parent'">

                      {{ all_field_datas[key] }}

              <AccountAutocomplete ref="EditAccountParentRef" class="searchbox" :list="getParentCompany"
                :searchOn="'parent'">
              </AccountAutocomplete>


                    <!-- <v-select name="parent" class="parent" label="name_1"
                    :options="all_countries" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="all_field_datas[key]" /> -->
                   </template>
  
                   <template v-else-if="field_array_column.identifier == 'head_office_country'">
                    <v-select name="head_office_country" class="head_office_country" label="name_1"
                    :options="all_countries" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="all_field_datas[key]" />
                  
                  </template>
  
                  <template v-else-if="field_array_column.identifier == 'registration_jurisdiction'">
                    <v-select name="registration_jurisdiction" class="registration_jurisdiction" label="name_1"
                    :options="all_countries" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="all_field_datas[key]" />
                  
                  </template>
  
  
  
                  <!-- <template v-else-if="field_array_column.identifier == 'phone_type'">
                    <div class="vx-col sm:w-1/3 w-full">
                      <v-select 
                        label="name" :options="phoneTypes" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="all_field_datas[key]" />
                    </div>
                  </template>
  
                  
  
                  <template v-else-if="field_array_column.identifier == 'phone_code'">
  
                    <div class="vx-col sm:w-1/3 w-full">
                      <v-select 
                        label="phone_code" :options="all_phone_codes" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="all_field_datas[key]" />
                    </div>
                  </template> -->


                  <template v-else-if="field_array_column.identifier == 'phone'">


                    <template
                    v-for="(w, index) in all_field_datas[key]"
                  >

                    <div class="flex mb-4">



                      <div class="w-3/4 bg-grid-color-secondary h-12 mr-5">
                        <v-select
                        name="phone_code"
                        class="phone_code"
                        label="name_with_code"
                        :options="all_phone_codes"
                        :dir="$vs.rtl ? 'rtl' : 'ltr'"
                        v-model="all_field_datas[key][index]['phone_code']"
                      />
                        </div>
    
                        <div class="w-3/4 bg-grid-color-secondary h-12 mr-5">
                          <vs-input
                          class="w-full"
                          name="phone"
                          v-model="all_field_datas[key][index]['phone_no']"
                        />
                        </div>
                        <div class="w-3/4 bg-grid-color-secondary h-12 mr-5">
                          <v-select
                            label="slug"
                            :options="phoneTypes"
                            :dir="$vs.rtl ? 'rtl' : 'ltr'"
                            v-model="all_field_datas[key][index]['phone_type']"
                          />
                          <!-- <vs-input class="w-full mb-2" v-model="d.phone_type" /> -->
                        </div>



                       


                      
                      <div class="w-1/5 bg-grid-color h-12">
                        <vs-icon
                          class="removeButton"
                          @click="removeSelectedPhone(key, w)"
                          color="success"
                          icon="clear"
                        >
                        </vs-icon>
                      </div>
                    </div>
                  </template>


              
                    <vs-button
                  @click="addPhone(field_array_column.column_id)"
                  color="primary"
                  type="filled"
                  >Add</vs-button
                >
                  </template>
                  
                  <template v-else-if="field_array_column.identifier == 'switchboard_phone_code'">
                    </template>

  
                  <template v-else-if="field_array_column.identifier == 'switchboard'">

                    <div class="flex mb-4">

                    <div class="w-1/4 bg-grid-color-secondary h-12 mr-5">
                      <v-select 
                        label="phone_code" :options="all_phone_codes" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="all_field_datas['_e4329196_efa0_417b_93a2_e12ec28ece85']" />
                    </div>


                    <div class="w-3/4 bg-grid-color-secondary h-12 mr-5">

                    <vs-input
                    class="w-full" v-model="all_field_datas[key]" :name="field_array_column.column_id" 
                     :data-vv-as="field_array_column.column_id" />

                     </div>
                     </div>


                  </template>
  
                  <template v-else-if="field_array_column.identifier == 'sic_code'">
                    <div class="vx-col sm:w-1/3 w-full">
  
                      <v-select 
                      label="code" :options="all_sic_codes" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="all_field_datas[key]" />
                  </div>
                     
                  </template>
  
                  <template v-else-if="field_array_column.identifier == 'vertical'">
                    <div class="vx-col sm:w-1/3 w-full">
  
                      <v-select 
                      label="vertical" :options="all_verticals" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="all_field_datas[key]" />
                  </div>
                     
                  </template>

                  <template v-else-if="field_array_column.identifier == 'revenue'">
                    <div class="vx-col sm:w-1/3 w-full">


                      <input type="number" 
                      class="vs-input-class" v-model="all_field_datas[key]" :name="field_array_column.column_id"
                       :data-vv-as="field_array_column.column_id" />
  
                     
                  </div>
                     
                  </template>

                  <template v-else-if="field_array_column.identifier == 'no_of_employees'">
                    <div class="vx-col sm:w-1/3 w-full">


                      <input type="number" 
                      class="vs-input-class" v-model="all_field_datas[key]" :name="field_array_column.column_id"
                       :data-vv-as="field_array_column.column_id" />
  
                     
                  </div>
                     
                  </template>
  
                  <template v-else-if="field_array_column.identifier == 'currency_code'">
                    <div class="vx-col sm:w-1/3 w-full">
  
                      <v-select
                      label="code" :options="all_currency_codes" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="all_field_datas[key]" />
                  </div>
                     
                  </template>

                  <template v-else-if="field_array_column.identifier == 'website'">


                    <template
                    v-for="(w, index) in all_field_datas[key]"
                  >

                    <div class="flex mb-4">
                      <div class="w-3/4 bg-grid-color-secondary h-12 mr-5">
                        <vs-input
                          class="w-full"
                          name="website_url"
                          v-validate="'url:require_protocol'"
                          v-model="all_field_datas[key][index]['url']"
                          data-vv-as="website"
                        />
                      </div>
                      <div class="w-1/5 bg-grid-color h-12">
                        <vs-icon
                          class="removeButton"
                          @click="removeSelectedWeb(key, w)"
                          color="success"
                          icon="clear"
                        >
                        </vs-icon>
                      </div>
                    </div>
                  </template>

                  <vs-button
                  @click="addWebsite(field_array_column.column_id)"
                  color="primary"
                  type="filled"
                  >Add</vs-button
                >
                     
                  </template>

                  <template v-else-if="field_array_column.identifier == 'linkedin'">


                    <template
                    v-for="(w, index) in all_field_datas[key]"
                  >

                    <div class="flex mb-4">
                      <div class="w-3/4 bg-grid-color-secondary h-12 mr-5">
                        <vs-input
                          class="w-full"
                          name="url"
                          v-validate="'url:require_protocol'"
                          v-model="all_field_datas[key][index]['url']"
                          data-vv-as="linkedin"
                        />
                      </div>
                      <div class="w-1/5 bg-grid-color h-12">
                        <vs-icon
                          class="removeButton"
                          @click="removeSelectedLinkedin(key, w)"
                          color="success"
                          icon="clear"
                        >
                        </vs-icon>
                      </div>
                    </div>
                  </template>

                  <vs-button
                  @click="addLinkedIn(field_array_column.column_id)"
                  color="primary"
                  type="filled"
                  >Add</vs-button
                >
                     
                  </template>
                  
  
  
  
                  <template v-else>


                    <template v-if="field_array_column.identifier == 'none_core_field'">






                      <template v-if="field_array_column.type == 'number'">
                        <input type="number" 
                          class="vs-input-class" v-model="all_field_datas[key]" :name="field_array_column.column_id"
                           :data-vv-as="field_array_column.column_id" />

                          



                        </template>
  
                        <template v-else-if="field_array_column.type == 'text' || field_array_column.type == 'client_contact'">
                          <vs-input
                            class="w-full" v-model="all_field_datas[key]" :name="field_array_column.column_id" v-validate="field_array_column.mandatory?'required':''"
                             :data-vv-as="field_array_column.column_id" />
                           
                        </template>
  
                        <template v-else-if="field_array_column.type == 'date'">

                          <flat-pickr
                            :config="configDateTimePicker"
                            placeholder="Choose Date"
                            name="audit_date_time"
                            v-model="all_field_datas[key]"
                          />
                        </template>

                          <template v-else-if="field_array_column.type == 'datetime'">

                          <flat-pickr
                            :config="configDateAndTimePicker"
                            placeholder="Choose Date And Time"
                            name="audit_date_and_time"
                            v-model="all_field_datas[key]"
                          />
                        </template>
  
                        <template v-else-if="field_array_column.type == 'choose_one'">


                          <span v-for="val, k in JSON.parse(field_array_column.values)">

                            <input class="ml-4" :name="key" :value="val.value" type="radio" v-model="all_field_datas[key]" />
                            {{ val.value }}
                          </span>

                          <!-- <v-select
                            label="value"
                            :name="key"
                            :options="JSON.parse(field_array_column.values)"
                            :dir="$vs.rtl ? 'rtl' : 'ltr'"
                            v-model="all_field_datas[key]"
                            v-validate="'required'"
                            data-vv-as="Action Type"
                          /> -->
                        </template>
  
                        <template v-else-if="field_array_column.type == 'dropdown'">


                          <v-select
                            label="value"
                            :name="key"
                            :options="JSON.parse(field_array_column.values)"
                            :dir="$vs.rtl ? 'rtl' : 'ltr'"
                            v-model="all_field_datas[key]"
                            v-validate="'required'"
                            data-vv-as="Action Type"
                          />
                        </template>
  
                        <template v-else-if="field_array_column.type == 'checkbox'">



                          <span v-for="(v, v_key) in JSON.parse(field_array_column.values)" class="p-2">

                          
                            <input
                              type="checkbox"
                              class="mr-2"
                              :value="v.value"
                              :id="field_array_column.column_id"
                                        v-model="all_field_datas[key]"
                              :checked="
                              all_field_datas[key] != null &&
                              all_field_datas[key].includes(v.value)
                              "
                             
                            />
              
                            {{ v.value }}
                          </span>

                        
                        </template>

                        <template v-else-if="field_array_column.type == 'textarea'">



                          <vue-trumbowyg v-model="all_field_datas[key]" 
                          :config="configs.basic"></vue-trumbowyg>
                       
  

                      </template>
                    </template>

                      <template v-else>

                       


                        <vs-input
                        class="w-full" v-model="all_field_datas[key]" :name="field_array_column.column_id" 
                         :data-vv-as="field_array_column.column_id" />
                         

                      </template>

  
                 
               
        
               </template>
                    </div>
        </div>
              </div>
             </template>
  
  
          </template>
  
  
        </template>

        <div class="vx-row mb-10">
          <div class="vx-col sm:w-1/2 w-full"></div>
          <div class="vx-col sm:w-1/2 w-full">
            <vs-button @click.prevent="updateSDAccountForm">Submit</vs-button>
          </div>
        </div>
      </vs-popup>

      <vs-popup
        :title="'Edit Contact'"
        fullscreen
        :active.sync="editSDContactPopUp"
      >


      
     
      <template v-for="(value,key) in all_contact_field_datas">
      

        <template v-for="field_array_column in  all_contact_field_datas['campaign_data_options']">

          


           <template v-if="field_array_column.column_id == key && field_array_column.level == 'contact' && field_array_column.identifier != 'ddi_phone_code' && field_array_column.identifier != 'mobile_phone_code' && field_array_column.identifier != 'contact_social_media_summary'">



            <div class="vx-row mb-6">

              <div class="vx-col sm:w-1/5 w-full">
                <span>{{ field_array_column.name }} </span>
              </div>
             
              <div class="vx-col sm:w-2/3 w-full">
                <div class="vx-col sm:w-2/3 w-full">

                  <!-- {{field_array_column}} -->


                  <template v-if="field_array_column.identifier == 'role'">

                    <v-select name="role" class="role" label="role"
                    :options="all_roles" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="all_contact_field_datas[key]" />
                   </template>
                   


                   <template v-else-if="field_array_column.identifier == 'sub_role'">

                    <v-select name="sub_role" class="sub_role" label="sub_role"
                    :options="all_sub_roles" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="all_contact_field_datas[key]" />
                   </template>

                   <template v-else-if="field_array_column.identifier == 'seniority'">

                    <div class="vx-col sm:w-1/3 w-full">
                      <v-select 
                        label="seniority" :options="all_seniorities" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="all_contact_field_datas[key]" />
                    </div>
                  </template>

                  <template v-else-if="field_array_column.identifier == 'ddi'">


                    <template
                    v-for="(w, index) in all_contact_field_datas[key]"
                  >

                    <div class="flex mb-4">





                      <div class="w-1/3 bg-grid-color-secondary h-12 mr-5">
                        <v-select
                        name="phone_code"
                        class="phone_code"
                        label="name_with_code"
                        :options="all_phone_codes"
                        :dir="$vs.rtl ? 'rtl' : 'ltr'"
                        v-model="all_contact_field_datas[key][index]['ddi_phone_code']"
                      />
                        </div>
    
                        <div class="w-2/3 bg-grid-color-secondary h-12 mr-5">
                          <vs-input
                          class="w-full"
                          name="phone"
                          v-model="all_contact_field_datas[key][index]['ddi']"
                        />
                        </div>
                        



                       


                      
                      <div class="w-1/5 bg-grid-color h-12">
                        <vs-icon
                          class="removeButton"
                          @click="removeSelectedDDI(key, w)"
                          color="success"
                          icon="clear"
                        >
                        </vs-icon>
                      </div>
                    </div>
                  </template>


              
                    <vs-button
                  @click="addDDI(field_array_column.column_id)"
                  color="primary"
                  type="filled"
                  >Add</vs-button
                >
                  </template>

                  <template v-else-if="field_array_column.identifier == 'mobile'">


                    <template
                    v-for="(w, index) in all_contact_field_datas[key]"
                  >

                    <div class="flex mb-4">



                      <div class="w-1/3 bg-grid-color-secondary h-12 mr-5">
                        <v-select
                        name="phone_code"
                        class="phone_code"
                        label="name_with_code"
                        :options="all_phone_codes"
                        :dir="$vs.rtl ? 'rtl' : 'ltr'"
                        v-model="all_contact_field_datas[key][index]['mobile_phone_code']"
                      />
                        </div>
    
                        <div class="w-2/3 bg-grid-color-secondary h-12 mr-5">
                          <vs-input
                          class="w-full"
                          name="phone"
                          v-model="all_contact_field_datas[key][index]['mobile']"
                        />
                        </div>
                        



                       


                      
                      <div class="w-1/5 bg-grid-color h-12">
                        <vs-icon
                          class="removeButton"
                          @click="removeSelectedMobile(key, w)"
                          color="success"
                          icon="clear"
                        >
                        </vs-icon>
                      </div>
                    </div>
                  </template>


              
                    <vs-button
                  @click="addMobile(field_array_column.column_id)"
                  color="primary"
                  type="filled"
                  >Add</vs-button
                >
                  </template>


              

                <template v-else-if="field_array_column.identifier == 'contact_social_media'">

                  <template
                  v-for="(w, index) in all_contact_field_datas[key]"
                >
                
                
                  <div class="flex mb-4">
                    <div class="w-3/4 bg-grid-color-secondary h-12 mr-5">
                      <vs-input
                        class="w-full"
                        name="contact_social_media"
                        v-model="all_contact_field_datas[key][index]['social_media']"
                        data-vv-as="contact_social_media"
                      />
                    </div>
                    <div class="w-3/4 bg-grid-color-secondary h-12 mr-5">
                      <vs-textarea class="w-full mb-2" v-model="all_contact_field_datas[key][index]['summary']"/>
                    </div>
                    <div class="w-1/5 bg-grid-color h-12">
                      <vs-icon
                        class="removeButton"
                        @click="removeSelectedSocialMedia(key, w)"
                        color="success"
                        icon="clear"
                      >
                      </vs-icon>
                    </div>
                  </div>
                </template>
                
                <vs-button
                @click="addSocialMedia(field_array_column.column_id)"
                color="primary"
                type="filled"
                >Add</vs-button
                >
                   
                </template>


                <template v-else-if="field_array_column.identifier == 'email'">


                  <template
                  v-for="(w, index) in all_contact_field_datas[key]"
                >


                  <div class="flex mb-4">
                    <div class="w-3/4 bg-grid-color-secondary h-12 mr-5">
                      <vs-input
                        class="w-full"
                        name="email"
                        v-model="all_contact_field_datas[key][index]['email']"
                        data-vv-as="email"
                      />
                    </div>
                    <vs-icon
                    style="cursor: pointer"
                    @click="validateEmailZeroBounce(all_contact_field_datas[key][index]['email'])"
                    color="success"
                    icon="checkmark"
                  ></vs-icon>
                    <div class="w-1/5 bg-grid-color h-12">
                      <vs-icon
                        class="removeButton"
                        @click="removeSelectedEmail(key, w)"
                        color="success"
                        icon="clear"
                      >
                      </vs-icon>
                    </div>
                  </div>

                </template>




                <vs-button
                @click="addEmail(field_array_column.column_id)"
                color="primary"
                type="filled"
                >Add</vs-button
              >

              <span class="pl-20">{{ email_validate_status }}</span>

                   
                </template>

                
                



                <template v-else>


                  <template v-if="field_array_column.identifier == 'none_core_field'">




                    <template v-if="field_array_column.type == 'number'">
                      <input type="number" 
                        class="vs-input-class" v-model="all_contact_field_datas[key]" :name="field_array_column.column_id"
                         :data-vv-as="field_array_column.column_id" />

                        



                      </template>

                      <template v-else-if="field_array_column.type == 'text' || field_array_column.type == 'client_contact'">
                        <vs-input
                          class="w-full" v-model="all_contact_field_datas[key]" :name="field_array_column.column_id" v-validate="field_array_column.mandatory?'required':''"
                           :data-vv-as="field_array_column.column_id" />
                         
                      </template>

                      <template v-else-if="field_array_column.type == 'date'">

                        <flat-pickr
                          :config="configDateTimePicker"
                          placeholder="Choose Date"
                          name="audit_date_time"
                          v-model="all_contact_field_datas[key]"
                        />
                      </template>

                       <template v-else-if="field_array_column.type == 'datetime'">

                        <flat-pickr
                          :config="configDateAndTimePicker"
                          placeholder="Choose Date And Time"
                          name="audit_date_and time"
                          v-model="all_contact_field_datas[key]"
                        />
                      </template>

                      <template v-else-if="field_array_column.type == 'choose_one'">

                        <span v-for="val, k in JSON.parse(field_array_column.values)">

                          <input class="ml-4" :name="key" :value="val.value" type="radio" v-model="all_contact_field_datas[key]" />
                          {{ val.value }}
                        </span>
                        <!-- <v-select
                          label="value"
                          :name="key"
                          :options="JSON.parse(field_array_column.values)"
                          :dir="$vs.rtl ? 'rtl' : 'ltr'"
                          v-model="all_contact_field_datas[key]"
                          v-validate="'required'"
                          data-vv-as="Action Type"
                        /> -->
                      </template>

                      <template v-else-if="field_array_column.type == 'dropdown'">


                        <v-select
                          label="value"
                          :name="key"
                          :options="JSON.parse(field_array_column.values)"
                          :dir="$vs.rtl ? 'rtl' : 'ltr'"
                          v-model="all_contact_field_datas[key]"
                          v-validate="'required'"
                          data-vv-as="Action Type"
                        />
                      </template>

                      <template v-else-if="field_array_column.type == 'checkbox'">


                        

                        <span v-for="(v, v_key) in JSON.parse(field_array_column.values)" class="p-2">

                          
              <input
                type="checkbox"
                class="mr-2"
                :value="v.value"
                :id="field_array_column.column_id"
                          v-model="all_contact_field_datas[key]"
                :checked="
                all_contact_field_datas[key] != null &&
                all_contact_field_datas[key].includes(v.value)
                "
               
              />

              {{ v.value }}
            </span>

                      
                      </template>

                      <template v-else-if="field_array_column.type == 'textarea'">



                        <vue-trumbowyg v-model="all_contact_field_datas[key]" 
                        :config="configs.basic"></vue-trumbowyg>


                     


                    </template>
                  </template>

                    <template v-else>

                     


                      <vs-input
                      class="w-full" v-model="all_contact_field_datas[key]" :name="field_array_column.column_id" 
                       :data-vv-as="field_array_column.column_id" />
                       

                    </template>


               
             
      
             </template>
                  </div>
      </div>
            </div>
           </template>


        </template>


      </template>
     

      

       

        <div class="vx-row mb-10">
          <div class="vx-col sm:w-1/2 w-full"></div>
          <div class="vx-col sm:w-1/2 w-full">
            <vs-button @click.prevent="updateSDContactForm">Submit</vs-button>
          </div>
        </div>
      </vs-popup>

        <dialog-drag
          :title="'Audit Trial - Dial'"
          id="dialogDialBox"
          @load="loadContent"
          :options="vueDraggableDialPopUpOptions"
          v-if="AuditTrialWithDialPopupActive"
        >

        <!-- <div class="text-center">
          <h6 class="mb-5"> {{ selected_account_contact._ec41e532_632d_4323_8071_f60b4543a68a + ' - ' + selected_account_contact._78540c9c_ce81_4ec0_8320_31838956392a + ' ' + selected_account_contact._755c8e1e_1725_4653_93f6_b8a888f4a423 }}</h6>
         </div> -->
          <h5>
            <vs-row v-if="auditTrialWithDial">
              <div class="vx-row w-full mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                  <span>Outcome:</span>
                </div>
                <div class="vx-col sm:w-1/2 w-full">
                  <v-select
                    label="name"
                    name="audit_trial_outcome"
                    :options="outcomes"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    v-model="audit_trial_with_dial.outcome"
                    v-validate="'required'"
                    data-vv-as="Outcome"
                  />
                  <!-- <span class="text-danger text-sm mt-2" v-show="errors.has('audit_trial_outcome')">{{
                  errors.first("audit_trial_outcome")
                }}</span> -->
                </div>
              </div>

              <div class="vx-row w-full mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                  <span>Notes:</span>
                </div>
                <div class="vx-col sm:w-1/2 w-full">
                  <vs-textarea
                    class="w-full mb-2"
                    name="notes"
                    v-model="audit_trial_with_dial.notes"
                  />
                </div>
              </div>

              <div
                class="vx-row w-full mb-6"
                v-if="selected_options.length != 0"
              >
                <div class="vx-col sm:w-1/3 w-full"></div>
                <div class="vx-col sm:w-1/2 w-full">
                  <vs-button
                    v-if="selected_options.includes('submit')"
                    class="mr-3 mb-2"
                    @click.prevent="submitAuditTrialWithDialForm"
                    >Submit</vs-button
                  >
                  <vs-button
                    v-if="selected_options.includes('schedule_a_next_action')"
                    class="mr-3 mb-2"
                    @click.prevent="scheduleANextAction"
                    >Schedule a Next Action</vs-button
                  >
                  <vs-button
                    v-if="
                      selected_options.includes(
                        'no_i_dont_to_schedule_a_next_action'
                      )
                    "
                    class="mr-3 mb-2"
                    @click.prevent="noIdontToScheduleANextAction"
                    >No, I don't want to schedule a next action</vs-button
                  >
                  <vs-button
                    v-if="selected_options.includes('next')"
                    class="mr-3 mb-2"
                    @click.prevent="dialNext"
                    >Next
                  </vs-button>
                </div>
              </div>

              <!-- <div class="vx-row w-full mb-6">
              <div class="vx-col sm:w-1/3 w-full"></div>
              <div class="vx-col sm:w-1/2 w-full">
                <vs-button
                  class="mr-3 mb-2"
                  @click.prevent="submitAuditTrialWithDialForm"
                  >Submit</vs-button
                >
              </div>
            </div> -->
            </vs-row>
          </h5>
        </dialog-drag>
        <vs-popup
          title="Schedule a Next Action"
          :active.sync="showSchedulePopUp"
          :button-close-hidden="true"
          @close="closeshowSchedulePopup"
        >
          <h5>
            <vs-row>
              <div class="vx-row w-full mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                  <span>Company Name:</span>
                </div>
                <div class="vx-col sm:w-1/2 w-full">
                  {{
                    selected_contact_aggrid_node
                      ? selected_contact_aggrid_node.data.company
                      : ''
                  }}
                </div>
              </div>
              <div class="vx-row w-full mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                  <span>Contact Name:</span>
                </div>
                <div class="vx-col sm:w-1/2 w-full">
                  {{
                    selected_contact_aggrid_node
                      ? selected_contact_aggrid_node.data._78540c9c_ce81_4ec0_8320_31838956392a +
                        ' ' +
                        selected_contact_aggrid_node.data._755c8e1e_1725_4653_93f6_b8a888f4a423
                      : ''
                  }}
                </div>
              </div>
              <div class="vx-row w-full mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                  <span>Job Role:</span>
                </div>
                <div class="vx-col sm:w-1/2 w-full">
                  {{
                    selected_contact_aggrid_node
                      ? selected_contact_aggrid_node.data._bd654e2e_a6c3_426a_8486_30e753088090
                      : ''
                  }}
                </div>
              </div>
              <div class="vx-row w-full mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                  <span>Start Date/Time:</span>
                </div>
                <div class="vx-col sm:w-1/2 w-full">
                  <flat-pickr
                    :config="configDateAndTimePicker"
                    placeholder="Choose Date And Time"
                    name="audit_date_time"
                    v-model="schedule_a_next_action.start_date_time"
                  />
                </div>
              </div>

              <div class="vx-row w-full mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                  <span>End Date/Time:</span>
                </div>
                <div class="vx-col sm:w-1/2 w-full">
                  <flat-pickr
                    :config="configDateAndTimePicker"
                    placeholder="Choose Date And Time"
                    name="audit_date_time"
                    v-model="schedule_a_next_action.end_date_time"
                  />
                </div>
              </div>
              <div class="vx-row w-full mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                  <span>Subject:</span>
                </div>
                <div class="vx-col sm:w-1/2 w-full">
                  <vs-input
                    name="notes"
                    class="w-full mb-2"
                    v-model="schedule_a_next_action.subject"
                  />
                </div>
              </div>

              <div class="vx-row w-full mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                  <span>Notes:</span>
                </div>
                <div class="vx-col sm:w-1/2 w-full">
                  <vs-textarea
                    class="w-full mb-2"
                    name="notes"
                    v-model="schedule_a_next_action.notes"
                  />
                </div>
              </div>

              <div class="vx-row w-full mb-6">
                <div class="vx-col sm:w-1/3 w-full"></div>
                <div class="vx-col sm:w-1/2 w-full">
                  <vs-button
                    class="mr-3 mb-2"
                    @click.prevent="addscheduleToCalendar"
                    >Submit</vs-button
                  >
                </div>
              </div>
            </vs-row>
          </h5>
        </vs-popup>
        <vs-popup
          fullscreen
          title="Choose Grade"
          :active.sync="showGradePopUp"
          :button-close-hidden="true"
          @close="closeshowGradePopup"
        >
          <vs-row>
            <vs-col vs-type="flex" vs-w="12">
              <div class="vx-row w-full mb-10 mt-5">
                <div class="vx-col sm:w-1/6 w-full">
                  <h6>Choose Grade:</h6>
                </div>
                <div class="vx-col sm:w-1/6 w-full">
                  <select v-model="grades.grade" class="w-full sm:w-1/3 p-2">
                    <option
                      v-for="item in grade_options"
                      :disabled="item.grade == '2'"
                      :value="item"
                    >
                      {{ item.grade }}
                    </option>
                  </select>

                  <!-- <v-select v-model="grades.grade" label="grade" item-disabled="disabled" :options="grade_options" name="grade" /> -->
                </div>
                <div class="vx-col sm:w-1/6 w-full">
                  <vs-button @click.prevent="openGradeStepsPopUp"
                    >Submit</vs-button
                  >
                </div>
              </div>
            </vs-col>

            <vs-row>
              <vs-col vs-type="flex" vs-w="12">
                <div class="vx-row w-full mb-10 mt-5">
                  <vs-table :data="grade_description">
                    <template slot="thead">
                      <vs-th>Grade</vs-th>
                      <vs-th>Explanation</vs-th>
                    </template>

                    <template slot-scope="{ data }">
                      <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td :data="data[indextr].grade">
                          {{ data[indextr].grade }}
                        </vs-td>

                        <vs-td :data="data[indextr].description">
                          {{ data[indextr].description }}
                        </vs-td>
                      </vs-tr>
                    </template>
                  </vs-table>
                </div>
              </vs-col>
            </vs-row>
          </vs-row>
        </vs-popup>
        <vs-popup
        title="Grade Steps"
        fullscreen
        :active.sync="showGradeStepsPopUp"
        :button-close-hidden="true"
        @close="closeshowGradeStepsPopup"
      >
      
        <template v-if="step_by_step_grade_steps">
          <div class="text-center mb-5">
            <h4>{{ step_by_step_grade_steps.grade_step_name }}</h4>
          </div>
          <vs-row>
            <div
              class="vx-col w-full p-2"
              v-for="field in step_by_step_grade_steps.grade_fields"
            >

              <div
              class="vx-row p-5"
              v-if="
                field.field_desc &&
                field.level == 'account' &&
                field.field_desc.type != 'client_contact'
              "
            >
              <div class="vx-col sm:w-1/5 w-full">
                <h6>{{ field.field }}</h6>


              </div>
              <div
                class="vx-col sm:w-1/3 w-full"
                v-if="
                  field.field_desc.type == 'text' &&
                  editSelectedAccount.hasOwnProperty(
                    field.field_desc.column_id
                  )
                "
              >
                <vs-input
                  class="w-full"
                  v-model="
                    editSelectedAccount[field.field_desc.column_id]
                  "
                  name="name"
                />
              </div>

              <div
                class="vx-col sm:w-1/3 w-full"
                v-if="
                  field.field_desc.type == 'number' &&
                  editSelectedAccount.hasOwnProperty(
                    field.field_desc.column_id
                  )
                "
              >
                <vs-input
                  class="w-full"
                  v-model="
                    editSelectedAccount[field.field_desc.column_id]
                  "
                  name="name"
                  type="number"
                />
              </div>
              <div
                class="vx-col sm:w-1/3 w-full"
                v-if="
                  field.field_desc.type == 'textarea' &&
                  editSelectedAccount.hasOwnProperty(
                    field.field_desc.column_id
                  )
                "
              >
          
              <div :class="'textarea' + field.field_desc.column_id">

                <vue-trumbowyg v-model="editSelectedAccount[field.field_desc.column_id]" 
                :config="configs.basic"></vue-trumbowyg>

                </div>
              </div>
              <div
                class="vx-col sm:w-1/3 w-full"
                v-if="
                  field.field_desc.type == 'date' &&
                  editSelectedAccount.hasOwnProperty(
                    field.field_desc.column_id
                  )
                "
              >
                <flat-pickr
                  v-model="
                    editSelectedAccount[field.field_desc.column_id]
                  "
                  :config="configDateTimePicker"
                  placeholder="Choose Date"
                  name="continuous_date_end"
                />
              </div>

                 <div
                class="vx-col sm:w-1/3 w-full"
                v-if="
                  field.field_desc.type == 'datetime' &&
                  editSelectedAccount.hasOwnProperty(
                    field.field_desc.column_id
                  )
                "
              >
                <flat-pickr
                  v-model="
                    editSelectedAccount[field.field_desc.column_id]
                  "
                  :config="configDateAndTimePicker"
                  placeholder="Choose Date and Time"
                  name="continuous_date_time_end"
                />
              </div>

              <div
                class="vx-col sm:w-1/3 w-full"
                v-if="
                  field.field_desc.type == 'checkbox' &&
                  editSelectedAccount.hasOwnProperty(
                    field.field_desc.column_id
                  )
                "
              >






                <span
                  v-for="v in JSON.parse(field.field_desc.values)"
                  class="p-2"
                >



                
                  <input
                    type="checkbox"
                    class="mr-2"
                    :value="v.value"
                    :id="field.field_desc.column_id"
                    :checked="
                      editSelectedAccount[
                        field.field_desc.column_id
                      ].includes(v.value)
                    "
                    v-model="editSelectedAccount[field.field_desc.column_id]"
                  />
                  {{ v.value }}

                </span>
              </div>

              <div
                class="vx-col sm:w-1/3 w-full"
                v-if="
                  field.field_desc.type == 'dropdown' &&
                  editSelectedAccount.hasOwnProperty(
                    field.field_desc.column_id
                  )
                "
              >
                <v-select
                  v-model="
                    editSelectedAccount[field.field_desc.column_id]
                  "
                  label="value"
                  :options="JSON.parse(field.field_desc.values)"
                  name="type"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                />
              </div>

              <div
                class="vx-col sm:w-1/3 w-full"
                v-if="
                  field.field_desc.type == 'choose_one' &&
                  editSelectedAccount.hasOwnProperty(
                    field.field_desc.column_id
                  )
                "
              >
                <span
                  v-for="v in JSON.parse(field.field_desc.values)"
                  class="p-2"
                >
                  <vs-radio
                    :vs-name="field.field"
                    :vs-value="v.value"
                    class="mr-2"
                    v-model="
                      editSelectedAccount[field.field_desc.column_id]
                    "
                    >{{ v.value }}</vs-radio
                  >
                </span>
              </div>
            </div>

              <div
              class="vx-row p-5"
              v-if="
                field.field_desc &&
                field.level == 'contact' &&
                field.field_desc.type != 'client_contact'
              "
            >
              <div class="vx-col sm:w-1/5 w-full">
                <h6>{{ field.field }}</h6>
              </div>
              <div
                class="vx-col sm:w-1/3 w-full"
                v-if="
                  field.field_desc.type == 'text' &&
                  editSelectedContact.hasOwnProperty(
                    field.field_desc.column_id
                  )
                "
              >
                <vs-input
                  class="w-full"
                  v-model="
                    editSelectedContact[field.field_desc.column_id]
                  "
                  name="name"
                />
              </div>

              <div
                class="vx-col sm:w-1/3 w-full"
                v-if="
                  field.field_desc.type == 'number' &&
                  editSelectedContact.hasOwnProperty(
                    field.field_desc.column_id
                  )
                "
              >
                <vs-input
                  class="w-full"
                  v-model="
                    editSelectedContact[field.field_desc.column_id]
                  "
                  name="name"
                  type="number"
                />
              </div>
              <div
                class="vx-col sm:w-1/3 w-full"
                v-if="
                  field.field_desc.type == 'textarea' &&
                  editSelectedContact.hasOwnProperty(
                    field.field_desc.column_id
                  )
                "
              >
        

            <div id="text_editor">
              <vue-trumbowyg  v-model="editSelectedContact[field.field_desc.column_id]" 
              :config="configs.basic"></vue-trumbowyg>

            </div>
              </div>
              <div
                class="vx-col sm:w-1/3 w-full"
                v-if="
                  field.field_desc.type == 'date' &&
                  editSelectedContact.hasOwnProperty(
                    field.field_desc.column_id
                  )
                "
              >
                <flat-pickr
                  v-model="
                    editSelectedContact[field.field_desc.column_id]
                  "
                  :config="configDateTimePicker"
                  placeholder="Choose Date"
                  name="continuous_date_end"
                />
              </div>

                  <div
                class="vx-col sm:w-1/3 w-full"
                v-if="
                  field.field_desc.type == 'datetime' &&
                  editSelectedContact.hasOwnProperty(
                    field.field_desc.column_id
                  )
                "
              >
                <flat-pickr
                  v-model="
                    editSelectedContact[field.field_desc.column_id]
                  "
                  :config="configDateAndTimePicker"
                  placeholder="Choose Date And Time"
                  name="continuous_date_time_end"
                />
              </div>

              <div
                class="vx-col sm:w-1/3 w-full"
                v-if="
                  field.field_desc.type == 'checkbox' &&
                  editSelectedContact.hasOwnProperty(
                    field.field_desc.column_id
                  )
                "
              >
              <span
              v-for="v in JSON.parse(field.field_desc.values)"
              class="p-2"
            >

            
              <input
                type="checkbox"
                class="mr-2"
                :value="v.value"
                :id="field.field_desc.column_id
                "
                :checked="
                editSelectedContact[
                    field.field_desc.column_id
                  ] != null &&
                  editSelectedContact[
                    field.field_desc.column_id
                  ].includes(v.value)
                "
                v-model="editSelectedContact[field.field_desc.column_id]"

              />
              {{ v.value }}

            </span>
              </div>

              <div
                class="vx-col sm:w-1/3 w-full"
                v-if="
                  field.field_desc.type == 'dropdown' &&
                  editSelectedContact.hasOwnProperty(
                    field.field_desc.column_id
                  )
                "
              >
                <v-select
                  v-model="
                    editSelectedContact[field.field_desc.column_id]
                  "
                  label="value"
                  :options="JSON.parse(field.field_desc.values)"
                  name="type"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                />
              </div>

              <div
                class="vx-col sm:w-1/3 w-full"
                v-if="
                  field.field_desc.type == 'choose_one' &&
                  editSelectedContact.hasOwnProperty(
                    field.field_desc.column_id
                  )
                "
              >
                <span
                  v-for="v in JSON.parse(field.field_desc.values)"
                  class="p-2"
                >
                  <vs-radio
                    :vs-name="field.field"
                    :vs-value="v.value"
                    class="mr-2"
                    v-model="
                      editSelectedContact[field.field_desc.column_id]
                    "
                    >{{ v.value }}</vs-radio
                  >
                </span>
              </div>
            </div>

          

          
            </div>
            <div class="vx-row w-full mb-6">
              <div class="vx-col sm:w-1/3 w-full"></div>
              <div class="vx-col sm:w-1/2 w-full">
                <vs-button
                  class="mr-3 mb-2"
                  @click.prevent="
                    submitAndShowNextStep(
                      step_by_step_grade_steps.grade_step_id
                    )
                  "
                  >Submit</vs-button
                >
              </div>
            </div>
          </vs-row>
        </template>
        <template v-else>
          <div class="text-center">
            <h5 class="p-5">No Grade Steps has been found for this grade.</h5>
            <!-- <vs-button @click.prevent="createOpportunity">Create Opportunity</vs-button> -->
          </div>
        </template>
      </vs-popup>
        <vs-popup
        title="Opportunity Exists"
        :active.sync="showOpportunityExistsPopup"
        :button-close-hidden="true"
        @close="closeshowOpportunityExistsPopup"
      >
        <vs-row>
         

            <p>You already have an opportunity for this contact for {{  last_opportunity }}.  If you wish to edit the existing opportunity, please do this from the campaign opportunities page.  If you wish to create a second or additional opportunities please click the create opportunities button.  </p>
            <br>
            <vs-col vs-type="flex" vs-w="12">
            <div class="vx-row w-full p-5">
              <div class="vx-col sm:w-1/2 w-full">
                <vs-button @click.prevent="takeMeBackToCampaign"
                  >Take me back to the campaign</vs-button
                >
              </div>

              <div class="vx-col sm:w-1/2 w-full">
                <vs-button @click.prevent="createAdditionalOpportunities"
                  >I want to create additional opportunities </vs-button
                >
              </div>
            </div>
          </vs-col>
        </vs-row>
      </vs-popup>
      <vs-popup
      title="Opportunities"
      fullscreen
      :active.sync="showOpportunitiesPopUp"
      :button-close-hidden="true"
      @close="closeshowOpportunitiesPopup"
    >
      <vs-row>
        <div
          class="vx-col w-full p-2"
          v-for="field in opportunity_field_options"
          
        >




          <!-- // Opportunities FIELD -->
          <div
            class="vx-row p-5"
            v-if="field.field_type == 'opportunity_field'"
          >
            <div class="vx-col sm:w-1/5 w-full">
              <h6>{{ field.name }}</h6>
            </div>

           

            <div class="vx-col sm:w-2/3 w-full">
              <div
                class="vx-col sm:w-1/3 w-full"
                v-if="field.type == 'text'"
              >
                <vs-input
                  class="w-full"
                  v-model="
                    opportunity_field_datas[field.column_id].value
                  "
                  name="name"
                />
              </div>

              <div
              class="vx-col sm:w-1/3 w-full"
              v-if="field.type == 'client_contact'"
            >
              <div class="auto_search_container">
                <input
                  class="autocom"
                  type="text"
                  v-model="search"
                  @blur="toggle = false"
                  @focus="toggle = true"
                />
                <div class="results" v-if="toggle">
                  <div
                    class="result"
                    v-for="client_contact in newCampaignClientContacts"
                  >
                    <span
                      @click="selectResult(client_contact , field.column_id)"
                      @mousedown.prevent
                    >
                      {{ client_contact.full_name }}
                    </span>
                  </div>
                </div>
              </div>
            </div>

              <div
                class="vx-col sm:w-1/3 w-full"
                v-if="field.type == 'number'"
              >
                <vs-input
                  class="w-full"
                  v-model="
                    opportunity_field_datas[field.column_id].value
                  "
                  name="name"
                  type="number"
                />
              </div>
              <div
                class="vx-col sm:w-1/3 w-full"
                v-if="field.type == 'textarea'"
              >
               <vue-trumbowyg v-model="opportunity_field_datas[field.column_id].value" 
                :config="configs.basic"></vue-trumbowyg>
              </div>
              <div
                class="vx-col sm:w-1/3 w-full"
                v-if="field.type == 'date'"
              >
                <flat-pickr
                  v-model="
                    opportunity_field_datas[field.column_id].value
                  "
                  :config="configDateTimePicker"
                  placeholder="Choose Date"
                  name="continuous_date_end"
                />
              </div>

               <div
                class="vx-col sm:w-1/3 w-full"
                v-if="field.type == 'datetime'"
              >
                <flat-pickr
                  v-model="
                    opportunity_field_datas[field.column_id].value
                  "
                  :config="configDateAndTimePicker"
                  placeholder="Choose Date And Time"
                  name="continuous_date_time_end"
                />
              </div>

              <div
                class="vx-col sm:w-1/3 w-full"
                v-if="field.type == 'checkbox'"
              >
                <span v-for="v in JSON.parse(field.values)" class="p-2">
                  <input
                    :key="componentKey"
                    type="checkbox"
                    class="mr-2"
                    :value="v.value"
                    :id="
                      opportunity_field_datas[field.column_id].model
                    "
                    :checked="
                      opportunity_field_datas[field.column_id].value !=
                        null &&
                      opportunity_field_datas[
                        field.column_id
                      ].value.includes(v.value)
                    "
                    @click="checkOpportunitySelectedCheckboxField($event)"
                  />
                  {{ v.value }}
                </span>
              </div>

              <div
                class="vx-col sm:w-1/3 w-full"
                v-if="field.type == 'dropdown'"
              >
                <v-select
                  v-model="
                    opportunity_field_datas[field.column_id].value
                  "
                  label="value"
                  :options="JSON.parse(field.values)"
                  name="type"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                />
              </div>

              <div
                class="vx-col sm:w-1/3 w-full"
                v-if="field.type == 'choose_one'"
              >
                <span v-for="v in JSON.parse(field.values)" class="p-2">
                  <vs-radio
                    :vs-name="field.field"
                    :vs-value="v.value"
                    class="mr-2"
                    v-model="
                      opportunity_field_datas[field.column_id].value
                    "
                    >{{ v.value }}</vs-radio
                  >
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="vx-row w-full p-5">
          <div class="vx-col sm:w-1/5 w-full"></div>
          <div class="vx-col sm:w-1/3 w-full">
            <vs-button class="ml-3" @click.prevent="submitOpportunityValues"
              >Submit</vs-button
            >

            <vs-button
              class="ml-3"
              @click.prevent="createAnotherOpportunity"
              >Submit And Create Another</vs-button
            >
          </div>
        </div>
      </vs-row>
    </vs-popup>

        <vs-popup
          title="Choose Account Tag"
          fullscreen
          :active.sync="showTagAccountPopUp"
        >
          <vs-row>
            <vs-col vs-type="flex" vs-w="12">
              <div class="vx-row w-full mb-10 mt-5">
                <div class="vx-col sm:w-1/4 w-full">
                  <h6>Choose Tag:</h6>
                </div>
                <div class="vx-col sm:w-1/2 w-full">
                  <ul class="centerx mb-2">
                    <!-- <span v-for="(v, key) in all_account_tags" class="p-2">
              <input v-model="selected_tag" :id="v.id" type="checkbox" class="mr-2" :value="v.id"/>

              {{ v.tag }}
            </span> -->

                    <li v-for="v in all_account_tags" class="p-1">
                      <vs-checkbox
                        v-model="selected_account_tag"
                        :vs-value="v.id"
                        >{{ v.tag }}
                      </vs-checkbox>
                    </li>
                  </ul>
                  <span class="text-danger text-sm">{{
                    please_choose_account_tag
                  }}</span>
                  <vs-button
                    class="mt-5"
                    @click.prevent="submitAccountTagAction"
                    >Submit</vs-button
                  >
                </div>
                <div class="vx-col sm:w-1/4 w-full"></div>
              </div>
            </vs-col>
          </vs-row>
        </vs-popup>
        <vs-popup
          title="Choose Contact Tag"
          fullscreen
          :active.sync="showTagContactPopUp"
        >
          <vs-row>
            <vs-col vs-type="flex" vs-w="12">
              <div class="vx-row w-full mb-10 mt-5">
                <div class="vx-col sm:w-1/4 w-full">
                  <h6>Choose Tag:</h6>
                </div>
                <div class="vx-col sm:w-1/2 w-full">
                  <ul class="centerx mb-2">
                    <!-- <span v-for="(v, key) in all_account_tags" class="p-2">
              <input v-model="selected_tag" :id="v.id" type="checkbox" class="mr-2" :value="v.id"/>

              {{ v.tag }}
            </span> -->

                    <!-- {{ selected_contact_tag }} -->

                    <li v-for="v in all_contact_tags" class="p-1">
                      <vs-checkbox
                        v-model="selected_contact_tag"
                        :vs-value="v.id"
                        >{{ v.tag }}
                      </vs-checkbox>
                    </li>
                  </ul>
                  <span class="text-danger text-sm">{{
                    please_choose_tag
                  }}</span>
                  <vs-button
                    class="mt-5"
                    @click.prevent="submitContactTagAction"
                    >Submit</vs-button
                  >
                </div>
                <div class="vx-col sm:w-1/4 w-full"></div>
              </div>
            </vs-col>
          </vs-row>
        </vs-popup>
        <vs-popup title="Choose Account Status" :active.sync="showHideAccountStatusPopUp">
          <vs-row>
            <vs-col vs-type="flex" vs-w="12">
              <div class="vx-row w-full">
                <div class="vx-col sm:w-1/4 w-full">
                  <h6>Status:</h6>
                </div>
                <div class="vx-col sm:w-1/2 w-full">
                  <v-select
                    name="status"
                    label="status"
                    :options="all_sd_status"
                    v-model="selected_status"
                    v-validate="'required'"
                    data-vv-as="Status"
                  />
                  <span class="text-danger text-sm">{{
                    please_choose_status
                  }}</span>
                </div>
              </div>
            </vs-col>
                <vs-col vs-type="flex" vs-w="12" v-if="account_sub_statuses.length > 0">
              <div class="vx-row w-full mt-5">
                <div class="vx-col sm:w-1/4 w-full">
                  <h6>Sub Status:</h6>
                </div>
                <div class="vx-col sm:w-1/2 w-full">

                    <template v-for="sub_status in account_sub_statuses">
                        <input 
                          v-validate="'required'"
                          data-vv-as="Sub Status"
                          name="sub_status"
                          v-model="selected_account_sub_status"
                          :value="sub_status"
                          type="checkbox">
                         <span class="ml-2"> {{ sub_status.sub_status }} </span> 


                       </br>
               </template>



               
              
                </div>
              </div>
            </vs-col>

            <vs-col vs-type="flex" vs-w="12">
              <div class="vx-row w-full mt-5">
                <div class="vx-col sm:w-1/4 w-full">
                  <h6>Notes:</h6>
                </div>
                <div class="vx-col sm:w-1/2 w-full">
                  <vs-textarea
                    class="w-full"
                    name="selected_status_notes"
                    v-model="selected_status_notes"
                    v-validate="'required'"
                    data-vv-as="Status Notes"
                  />
                  <span class="text-danger text-sm">{{
                    please_choose_status_notes
                  }}</span>

                  <vs-button class="mt-5" @click.prevent="submitStatusAction"
                    >Submit</vs-button
                  >
                </div>
                <div class="vx-col sm:w-1/4 w-full"></div>
              </div>
            </vs-col>
          </vs-row>
        </vs-popup>


          <vs-popup title="Choose Contact Status" :active.sync="showHideContactStatusPopUp">
          <vs-row>
            <vs-col vs-type="flex" vs-w="12">
              <div class="vx-row w-full">
                <div class="vx-col sm:w-1/4 w-full">
                  <h6>Status:</h6>
                </div>
                <div class="vx-col sm:w-1/2 w-full">
                  <v-select
                    name="status"
                    label="status"
                    :options="all_sd_status"
                    v-model="selected_status"
                    v-validate="'required'"
                    data-vv-as="Status"
                  />
                  <span class="text-danger text-sm">{{
                    please_choose_status
                  }}</span>
                </div>
              </div>
            </vs-col>
                <vs-col vs-type="flex" vs-w="12" v-if="contact_sub_statuses.length > 0">
              <div class="vx-row w-full mt-5">
                <div class="vx-col sm:w-1/4 w-full">
                  <h6>Sub Status:</h6>
                </div>
                <div class="vx-col sm:w-1/2 w-full">

                    <template v-for="sub_status in contact_sub_statuses">
                        <input 
                          v-validate="'required'"
                          data-vv-as="Sub Status"
                          name="sub_status"
                          v-model="selected_contact_sub_status"
                          :value="sub_status"
                          type="checkbox">
                         <span class="ml-2"> {{ sub_status.sub_status }} </span> 


                       </br>
               </template>



              
              
                </div>
              </div>
            </vs-col>

            <vs-col vs-type="flex" vs-w="12">
              <div class="vx-row w-full mt-5">
                <div class="vx-col sm:w-1/4 w-full">
                  <h6>Notes:</h6>
                </div>
                <div class="vx-col sm:w-1/2 w-full">
                  <vs-textarea
                    class="w-full"
                    name="selected_status_notes"
                    v-model="selected_status_notes"
                    v-validate="'required'"
                    data-vv-as="Status Notes"
                  />
                  <span class="text-danger text-sm">{{
                    please_choose_status_notes
                  }}</span>

                  <vs-button class="mt-5" @click.prevent="submitStatusAction"
                    >Submit</vs-button
                  >
                </div>
                <div class="vx-col sm:w-1/4 w-full"></div>
              </div>
            </vs-col>
          </vs-row>
        </vs-popup>

        <vs-popup title="Save View" :active.sync="showHideSaveViewPopUp">
          <vs-row>
            <vs-col vs-type="flex" vs-w="12">
              <div class="vx-row w-full">
                <div class="vx-col sm:w-1/4 w-full">
                  <h6>Name:</h6>
                </div>
                <div class="vx-col sm:w-1/2 w-full">
                  <vs-input
                    class="w-full"
                    v-model="save_view_name"
                    name="name"
                  />
                  <span class="text-danger text-sm">{{
                    please_choose_save_view_name
                  }}</span>
                </div>
              </div>
            </vs-col>

            <vs-col vs-type="flex" vs-w="12">
              <div class="vx-row w-full mt-5">
                <div class="vx-col sm:w-1/4 w-full">
                  <h6>Description:</h6>
                </div>
                <div class="vx-col sm:w-1/2 w-full">
                  <vs-textarea
                    class="w-full"
                    name="save_view_description"
                    v-model="save_view_description"
                  />

                  <vs-button class="mt-5" @click.prevent="submitSaveViewAction"
                    >Submit</vs-button
                  >
                </div>
              </div>
            </vs-col>
          </vs-row>
        </vs-popup>
      </div>
    </div>
  </div>
</template>
<script>
var revanueValueFormatter = function (params) {
  return params.data.currency_name + ' ' + params.data.revenue
  // return '$' + params.value
}

var filterDateParams = {
  comparator: (filterLocalDateAtMidnight, cellValue) => {
    cellValue = moment(cellValue).format('DD/MM/YYYY')

    var dateAsString = cellValue;
    if (dateAsString == null) return -1;
    var dateParts = dateAsString.split('/');
    var cellDate = new Date(
      Number(dateParts[2]),
      Number(dateParts[1]) - 1,
      Number(dateParts[0])
    );

    if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
      return 0;
    }

    if (cellDate < filterLocalDateAtMidnight) {
      return -1;
    }

    if (cellDate > filterLocalDateAtMidnight) {
      return 1;
    }
    return 0;
  },
  inRangeFloatingFilterDateFormat: 'Do MMM YYYY',
  buttons: ["apply", "reset"],
  maxNumConditions: 4
};



var AccountsMultipleValueFormatter = function(params) {


if (params.column.colDef.identifier == 'website'){

              if (params.value.length == 0) {
                params.value = "";
              } else if (params.value.length > 1) {
                params.value = "ΞΞ";
              } else {
                params.value = params.value[0].url;
              }

              return params.value


}

if (params.column.colDef.identifier == 'linkedin'){

  if (params.value.length == 0) {
    params.value = "";
  } else if (params.value.length > 1) {
    params.value = "ΞΞ";
  } else {
    params.value = params.value[0].url;
  }

  return params.value
}

if (params.column.colDef.identifier == 'phone'){
if (params.value.length == 0) {
  params.value = "";
} else if (params.value.length > 1) {
  params.value = "ΞΞ";
} else {
  params.value = params.value[0].phone_code + params.value[0].phone_no;
}

return params.value
}

// if (params.column.colDef.identifier == 'mobile'){
// if (params.value.length == 0) {
//   params.value = "";
// } else if (params.value.length > 1) {
//   params.value = "ΞΞ";
// } else {
//   params.value = params.value[0].mobile_phone_code + params.value[0].mobile;
// }

// return params.value
// }

};


var ContactsMultipleValueFormatter = function(params) {




  if (params.column.colDef.field_type == 'core_field'){




    if (params.column.colDef.identifier == 'email'){

                if (params.value.length == 0) {
                  params.value = "";
                } else if (params.value.length > 1) {
                  params.value = "ΞΞ";
                } else {
                  params.value = params.value[0].email;
                }

                return params.value


  }
  if (params.column.colDef.identifier == 'contact_social_media'){



if (params.value.length == 0) {
  params.value = "";
} else if (params.value.length > 1) {
  params.value = "ΞΞ";
} else {

params.value = params.value[0].social_media


}

return params.value
}

if (params.column.colDef.identifier == 'ddi'){
  if (params.value.length == 0) {
    params.value = "";
  } else if (params.value.length > 1) {
    params.value = "ΞΞ";
  } else {
    params.value = params.value[0].ddi_phone_code + params.value[0].ddi;
  }

  return params.value
}

if (params.column.colDef.identifier == 'mobile'){
  if (params.value.length == 0) {
    params.value = "";
  } else if (params.value.length > 1) {
    params.value = "ΞΞ";
  } else {
    params.value = params.value[0].mobile_phone_code + params.value[0].mobile;
  }

  return params.value
}

  }

  

};
import moduleAccountsManagement from '@/store/accounts-management/moduleAccountsManagement.js'
import moduleContactsManagement from '@/store/contacts-management/moduleContactsManagement.js'
import DataGrid from '@/components/aggrid/Aggrid.vue'
import defineAbilitiesFor from '@/config/abilities'
import moduleCampaignsManagement from '@/store/campaign-management/moduleCampaignManagement.js'
import vSelect from 'vue-select'
import _ from 'lodash'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import SDAccountDataGrid from "@/components/aggrid/SDAccountAggrid.vue";
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import AccountAutocomplete from '@/components/autocomplete/AccountsAutocomplete.vue'
import moduleOutcomeManagement from '@/store/outcome-management/moduleOutcomeManagement.js'
import moduleAuditTrialManagement from '@/store/audit-trial-management/moduleAuditTrialManagement.js'
import moduleGradeManagement from '@/store/grade-management/moduleGradeManagement.js'
import moduleElomarkUserManagement from '@/store/elomark-user-management/moduleElomarkUserManagement.js'
import moduleSDSubStatusManagement from "@/store/sd-sub-status-management/moduleSDSubStatusManagement.js";
import moment from 'moment'
import ClientDataGrid from "@/components/aggrid/AggridClient.vue";
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { quillEditor } from 'vue-quill-editor'
import moduleTagManagement from '@/store/tag-management/moduleTagManagement.js'
import DialogDrag from 'vue-dialog-drag'


import VueTrumbowyg  from 'vue-trumbowyg';
import 'jquery-resizable-dom/dist/jquery-resizable.js';
import 'jquery-resizable-dom/dist/jquery-resizableTableColumns.js';

import 'trumbowyg/dist/trumbowyg.min.js';
import 'trumbowyg/dist/ui/trumbowyg.min.css';
import 'trumbowyg/dist/plugins/colors/ui/trumbowyg.colors.min.css';
import 'trumbowyg/dist/plugins/table/trumbowyg.table.min.js';
import 'trumbowyg/dist/plugins/table/ui/trumbowyg.table.min.css';
import 'trumbowyg/dist/plugins/fontsize/trumbowyg.fontsize.min.js';
import 'trumbowyg/dist/plugins/upload/trumbowyg.upload.min.js';
import 'trumbowyg/dist/plugins/colors/trumbowyg.colors.min.js'
import 'trumbowyg/dist/plugins/colors/ui/trumbowyg.colors.min.css'
import 'trumbowyg/dist/plugins/pasteimage/trumbowyg.pasteimage.min.js'
import 'trumbowyg/dist/plugins/preformatted/trumbowyg.preformatted.min.js'
import 'trumbowyg/dist/plugins/lineheight/trumbowyg.lineheight.min.js'
import 'trumbowyg/dist/plugins/indent/trumbowyg.indent.min.js'
import 'trumbowyg/dist/plugins/resizimg/trumbowyg.resizimg.js'
import axios from '@/axios.js'




import '@/assets/css/drag.css'
export default {
  data: () => ({
     user_role_id: null,
    account_sub_statuses: [],
    contact_sub_statuses: [],
    selected_account_sub_status: [],
    selected_contact_sub_status: [],
    no_of_campaign_accounts: 0,
    no_of_campaign_contacts: 0,
    configs: {
          basic: {
            autogrow: true,
            removeformatPasted: true,
            btns: [
                    ['strong', 'em'],
                    ['superscript', 'subscript'],
                    ['fontsize'],
                    ['foreColor', 'backColor'],
                    ['link'],
                    ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull'],
                    ['horizontalRule'],
                    ['removeformat'],
                    ['fullscreen']
                ],
                plugins: {
                    table: {
                        columns: 10,
                        rows: 10,
                    
                    },
                    resizimg: {
            minSize: 64,
            step: 16,
        }

                    }
                        }
      },
    all_seniorities : [],
      all_roles : [],
      all_sub_roles : [],
    all_currency_codes : [],
      all_verticals : [],
      all_sic_codes : [],
      all_countries : [],
    all_field_datas : {},
    all_contact_field_datas : {},
    acc_col : [],
    last_opportunity : null,
    showOpportunityExistsPopup : false,
    dial_counts: 0,
    viewing_as_full_name: null,
    sales_developer_id: null,
    email_validate_status: null,
    componentKey: 0,
    please_choose_account_tag: null,
    please_choose_contact_tag: null,
    selected_contact_tag: [],
    selected_account_tag: [],
    authorized: true,
    phoneTypes: [],
    selected_sd_account_id: null,
    selected_contact_status: null,
    selected_contact_table_id: null,
    selected_account_status: null,
    selected_account_table_id: null,
    selected_view_for_sd: null,
    sd_view_options: [],
    showHideSaveViewPopUp: false,
    please_choose_save_view_name: null,
    save_view_name: null,
    save_view_description: null,
    selected_status_notes: null,
    showAccountTagFilterOption: false,
    showContactTagFilterOption: false,
    selected_account_contact_status_data: null,
    selected_status: null,
    all_sd_status: [],
    showHideAccountStatusPopUp: false,
    showHideContactStatusPopUp: false,
    selected_filter_account_tag: [],
    selected_filter_contact_tag: [],
    all_contact_tags: [],
    accountNotes: null,
    contactNotes: null,
    selected_tag: [],
    please_choose_status: null,
    please_choose_status_notes: null,
    please_choose_tag: null,
    all_account_tags: [],
    showTagAccountPopUp: false,
    showTagContactPopUp: false,
    grade_description: [],
    selected_grade_steps: [],
    step_by_step_grade_steps: [],
    opportunity_fields: [],
    grades: {
      grade: null
    },
    grade_options: [],
    showGradePopUp: false,
    showGradeStepsPopUp: false,
    showOpportunitiesPopUp: false,
    selected_campaign: null,
    contactsAuditTrials: [],
    auditTrialWithDial: false,
    auditTrialSelectedContact: null,
    action_types: [],
    outcomes: [],
    audit_trial: {
      date_time: moment(new Date()).format('YYYY-MM-DD hh:mm:ss'),
      outcome: null,
      notes: null,
      action_type: null,
      campaign_id: null,
      sales_developer_id: null,
      account_id: null,
      contact_id: null
    },
    audit_trial_with_dial: {
      action_type: null,
      date_time: moment(new Date()).format('YYYY-MM-DD hh:mm:ss'),
      outcome: null,
      notes: null
    },
    schedule_a_next_action: {
      sales_developer_id: null,
      subject: null,
      start_date_time: moment(new Date()).format('YYYY-MM-DD hh:mm:ss'),
      end_date_time: moment(new Date()).format('YYYY-MM-DD hh:mm:ss'),
      campaign_id: null,
      notes: null,
      selected_account_contact: null
    },
    AuditTrialWithDialPopupActive: false,
    AuditTrialPopupActive: false,
    selectedDialAccountContact: null,
    showEditNumbers: false,
    listofNumbers: [],
    showDialTitle: null,
    user_id: null,
    showSocial_mediaExtraField: false,
    showEmailExtraField: false,
    showMobileExtraField: false,
    showDdiExtraField: false,
    showLinkedExtraField: false,
    showPhoneExtraField: false,
    showWebsiteExtraField: false,

    selectedEditContactId: null,
    website_counter: 0,

    websites: [
      {
        counter: 0,
        url: null
      }
    ],
    linkedin_counter: 0,

    linkedins: [
      {
        counter: 0,
        url: null
      }
    ],
    email_counter: 0,

    emails: [
      {
        counter: 0,
        email: null,
        is_primary: null
      }
    ],
    social_media_counter: 0,

    social_medias: [
      {
        counter: 0,
        social_media: '',
        summary: null,
        is_primary: null
      }
    ],
    mobile_counter: 0,

    mobiles: [
      {
        counter: 0,
        mobile: '',
        mobile_phone_code: null,
        is_primary: null
      }
    ],
    ddi_counter: 0,

    ddis: [
      {
        counter: 0,
        ddi: null,
        ddi_phone_code: null,
        is_primary: null
      }
    ],
    phone_counter: 0,

    phones: [
      {
        counter: 0,
        phone_no: '',
        phone_code: ''
      }
    ],
    checkedFields: {},
    opportunitiesCheckedFields: {},

    configDateTimePicker: {
      enableTime: false,
      dateFormat: 'Y-m-d'
    },
    configDateAndTimePicker: {
      enableTime: true,
      dateFormat: "Y-m-d H:i:s",
      enableSeconds : true
    },
    componentKey: 0,
    editSDAccountPopUp: false,
    editSDContactPopUp: false,

    dialPopupActive: false,
    abilities: null,
    accountSDQCAccountFields: [],
    contactSDQCContactFields: [],
    accountColumnDefs: [],
    contactsColumnDefs: [
      {
        headerName: 'Actions',
        sortable: false,

        field: 'transactions',
        cellRenderer: 'CellRendererActions',
        suppressHeaderMenuButton: true,
        pinned: true,
        width: 120
      }
    ],
    campaignFieldsDataSource: {},
    campaignFieldsRecords: [],
    campaignsRecords: [],
    selected_account_id: null,
    contactColumnDefs: [],
    campaignName: null,
    campaignDescription: [],
    accountRecords: null,
    campaignId: null,
    abilities: null,
    selected_contact_id: null,
    contactDataSource: {},
    getSDAccountSelectedFieldRecords: [],
    getSDContactSelectedFieldRecords: [],
    contactParamsRequest: {},
    editSelectedAccount: {},
    editSelectedContact: {},
    selectedEditCampaignId: null,
    selectedEditAccountId: null,
    master_field_options: null,
    client_field_options: null,
    campaign_field_options: null,
    opportunity_field_options: [],
    opportunity_field_datas: [],
    master_field_datas: {},
    client_field_datas: {},
    campaign_field_datas: {},
    contact_master_field_datas: {},
    contact_client_field_datas: {},
    contact_campaign_field_datas: {},
    core_field_datas: {},
    showHeadOfficeCountryField: true,
    showHeadOfficeEditAutocomplete: false,
    showRegisteredOfficeCountryField: true,
    showRegisteredOfficeEditAutocomplete: false,
    showRegistrationJurisdictionField: true,
    showRegistrationJurisdictionEditAutocomplete: false,
    showParentField: true,
    showParentEditAutocomplete: false,
    showVerticalField: true,
    showVerticalEditAutocomplete: false,
    showSatelliteOfficeCountryField: true,
    showSatelliteOfficeEditAutocomplete: false,
    roles: [],
    seniorities: [],
    sub_roles: [],
    primary_mobile: null,
    primary_ddi: null,
    dialAction: null,
    optionDescription: [],
    audittrial_action_type_id: null,
    audittrial_outcome_grade: null,
    audittrial_outcome_id: null,
    selected_options: [],
    showSchedulePopUp: false,
    selected_account_contact: null,
    old_master_field_datas: {},
    search: '',
    toggle: false,
    campaign_client_contacts: [],
    newCampaignClientContacts: [],
    showOpportunityPopUpFromGrade: false,
    campaign_view_settings: {
      auto_size_cell_contents: null,
      selected_contact_aggrid_node: null,
      selected_account_aggrid_node: null
    },
    lastPageAccount: 0,
    // vueDraggablePopUpOptions: {'width' : 600 , 'left': 600 , 'top' : 60, 'buttonPin' : false , zIndex: 9999999},
    vueDraggableDialPopUpOptions: {
      width: 600,
      centered: 'parent',
      buttonPin: false,
      buttonClose: false,
      zIndex: 9999999
    },
    vueDraggablePopUpOptions: {
      width: 600,
      centered: 'parent',
      buttonPin: false,
      zIndex: 9999999
    }
  }),
  components: {
    'v-select': vSelect,
    DataGrid,
    flatPickr,
    AccountAutocomplete,
    quillEditor,
    DialogDrag,
    SDAccountDataGrid,
    ClientDataGrid,
    VueTrumbowyg,
    moduleSDSubStatusManagement
  },
  watch: {
      selected_status (val) {
      if (val) {
        console.log("STATUS CHANGED" , val)
        this.fetchSDSubStatusByStatusIDAndRoleID(val.id , this.user_role_id)
      }
    },
    search (val) {
      let self = this
      self.newCampaignClientContacts = []

      self.campaign_client_contacts.forEach(element => {
        if (element.full_name.includes(val) && val != '') {
          self.newCampaignClientContacts.push(element)
        }
      })

      const key = 'user_id'

      self.newCampaignClientContacts = [
        ...new Map(
          self.newCampaignClientContacts.map(item => [item[key], item])
        ).values()
      ]
    },
    selected_view_for_sd (val) {
      if (val) {
        const account_saved_state = JSON.parse(val.account_view)
        this.$refs.SDQCAccount.gridApi.applyColumnState({
          state: account_saved_state,
          applyOrder: true
        })

        const contact_saved_state = JSON.parse(val.contact_view)
        this.$refs.SDQCContact.gridApi.applyColumnState({
          state: contact_saved_state,
          applyOrder: true
        })

        const account_filter_saved_state = JSON.parse(val.account_filter)
        this.$refs.SDQCAccount.gridApi.setFilterModel(
          account_filter_saved_state
        )

        const contact_filter_saved_state = JSON.parse(val.contact_filter)
        this.$refs.SDQCContact.gridApi.setFilterModel(
          contact_filter_saved_state
        )
      }
    },
    selected_filter_contact_tag (val) {
      this.$refs.SDQCContact.gridApi.refreshServerSide({ purge: true })
      // this.getContactDataSource()
    },
    selected_filter_account_tag (val) {

      let self = this

        if(val.length != 0){
            self.$refs.SDQCAccount.gridApi.setColumnFilterModel('tag', { values: val }).then(() => {
          self.$refs.SDQCAccount.gridApi.onFilterChanged();
        });

        }else{
          self.getAccountDataSource()
        }

      

      
    },
    role (val) {
      if (val) {
        this.sub_roles = []
        this.getSubRole(val.id)
      }
    },
    "all_contact_field_datas.role"(val) {

      alert("role")
      if (val) {
        this.getAllSubRole(val.id);
      }
    },
    'audit_trial.action_type' (action_type) {
      this.selected_options = []

      if(action_type){

        this.audittrial_action_type_id = action_type.id
      this.fetchAllOutcomesByActionType(action_type.id)

      }

    
    },
    'audit_trial.outcome' (val) {
      this.selected_options = []
      if(val){
        this.audittrial_outcome_id = val.id
        this.audittrial_outcome_grade = val.grade
      }
      this.fetchOptionsByActionTypeAndOutcome()
    },
    'audit_trial_with_dial.outcome' (val) {


    
      this.selected_options = []
      this.audittrial_action_type_id = this.dialAction.action_type_id

      if(val){
        this.audittrial_outcome_id = val.id
        this.audittrial_outcome_grade = val.grade
      }

      this.fetchOptionsByActionTypeAndOutcome()
    }
  },
  methods: {
          fetchSDSubStatusByStatusIDAndRoleID(status_id,role_id) {
      let self = this;
      this.$store
        .dispatch("SDSubStatusManagement/fetchSDSubStatusByStatusIDAndRoleID", {
          status_id: status_id,
          role_id: role_id
        })
        .then(res => {
          let result = JSON.parse(res.data);


          self.account_sub_statuses = []
          self.contact_sub_statuses = []

          result.forEach(function (ele) {
           if (ele.level == 'account'){
                self.account_sub_statuses.push(ele)
           }
           if (ele.level == 'contact'){
                self.contact_sub_statuses.push(ele)
           }
          });



  



        })
        .catch(err => {
          console.error(err);
        });
    },
    GradeChangedFilterView () {


      window.open("/views/all_sd_campaign_view/filter_grade_changed/" + this.$route.params.campaignId + "/" + this.$route.params.campaignName, '_blank');


      
      
    },
    AuditTrialChangedFilterView () {


window.open("/views/all_sd_campaign_view/filter_audit_trial_changed/" + this.$route.params.campaignId + "/" + this.$route.params.campaignName, '_blank');




},
    requestAccount () {


window.open("/views/all_sd_campaign_views/request_account/" + this.$route.params.campaignId , '_blank');




},
    requestContact (account_id) {


window.open("/views/all_sd_campaign_views/request_contact/" + this.$route.params.campaignId + '/' + account_id , '_blank');




},
    getAllSicCodes() {
     this.$store
        .dispatch("accountsManagement/getAllSicCodes")
        .then(response => {
          let data = response.data
          this.all_sic_codes = data
          // let mappedArray = [];
          // for (const property in data) {
          //   mappedArray.push({
          //     id: data[property].id,
          //     name: data[property].code + ' - ' + data[property].description
          //   });
          // }
          // return mappedArray;
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    getAllVerticals() {
     this.$store
        .dispatch("accountsManagement/getAllVerticals")
        .then(response => {
          let data = response.data
          this.all_verticals = data
          // let mappedArray = [];
          // for (const property in data) {
          //   mappedArray.push({
          //     id: data[property].id,
          //     name: data[property].code + ' - ' + data[property].description
          //   });
          // }
          // return mappedArray;
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    getAllCurrencyCodes() {
     this.$store
        .dispatch("accountsManagement/getAllCurrencyCodes")
        .then(response => {
          let data = response.data
          this.all_currency_codes = data
          // let mappedArray = [];
          // for (const property in data) {
          //   mappedArray.push({
          //     id: data[property].id,
          //     name: data[property].code + ' - ' + data[property].description
          //   });
          // }
          // return mappedArray;
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    takeMeBackToCampaign () {
      this.showOpportunityExistsPopup = false
    },
    createAdditionalOpportunities () {
      this.showOpportunityExistsPopup = false
      this.showOpportunitiesPopUp = true
    },
    loadContent () {
      // document.body.style.background = "yellow";
      // alert("sdfsdfsdf")
    },
    closeAuditTrialPopupActive () {
      this.AuditTrialPopupActive = false
    },
    getAllSeniority() {
      this.$store
        .dispatch("contactsManagement/getSeniority")
        .then(res => {
          this.all_seniorities = res.data;
        })
        .catch(err => {
          if (err.response.status === 401) {
          console.error(err);
    }
  })
    },
    getAllRoles() {
      this.$store
        .dispatch("contactsManagement/getRoles")
        .then(res => {
          this.all_roles = res.data;
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
    }
  })
    },
    getAllSubRole(role_id) {
      this.$store
        .dispatch("contactsManagement/getSubRoles", role_id)
        .then(res => {
          this.all_sub_roles = res.data;
        })
        .catch(err => {
          console.error(err);
        });
    },
    getSDCampaignViewSettings () {
      let self = this
      let data = {}
      data.user_id = self.user_id
      self.$store
        .dispatch('campaignsManagement/fetchAllSDCampaignViewSettings', data)
        .then(res => {
          let result = res.data
          if (result) {
            let result_data = JSON.parse(res.data)

            let newObj = {}

            result_data.forEach(function (ele) {
              newObj[ele.setting_type] = ele.status
            })

            self.campaign_view_settings = newObj

            let wrapText = false
            let autoHeight = false
            if (
              self.campaign_view_settings.auto_size_cell_contents == 'enabled'
            ) {
              wrapText = true
              autoHeight = true
            }

            self.accountSDQCAccountFields = [
              {
                flex: 1,
                headerName: 'Column',
                field: 'column',
                filter: 'agTextColumnFilter',
                filterParams: {
                  buttons: ['apply', 'reset'],
                  maxNumConditions: 4
                }
              },
              {
                flex: 1,
                headerName: 'Value',
                field: 'value',
                filter: 'agTextColumnFilter',
                filterParams: {
                  buttons: ['apply', 'reset'],
                  maxNumConditions: 4
                },
                wrapText: true,
                autoHeight: true,
                cellRenderer : function(params) {
                return params.value ? params.value : '';
            },
                valueGetter: (params) => {
      return params.data.value;
    },
              }
            ]

            self.contactSDQCContactFields = [
              {
                flex: 1,
                headerName: 'Column',
                field: 'column',
                filter: 'agTextColumnFilter',
                filterParams: {
                  buttons: ['apply', 'reset'],
                  maxNumConditions: 4
                }
              },
              {
                flex: 1,

                headerName: 'Value',
                field: 'value',
                filter: 'agTextColumnFilter',
                filterParams: {
                  buttons: ['apply', 'reset'],
                  maxNumConditions: 4
                },
                wrapText: true,
                autoHeight: true,


                cellRenderer : function(params) {
                return params.value ? params.value : '';
            },
                valueGetter: (params) => {
      return params.data.value;
    },
              }
            ]
          }
        })
    },
    contact_selected_role (event) {
      this.getSubRole(event.id)
    },
    getCampaignGrades (selected_campaign) {
      let self = this
      this.$store
        .dispatch('campaignsManagement/getCampaignGrades', selected_campaign)
        .then(res => {
          let result = res.data
          let grade_description = []

          self.grade_options.forEach(function (e) {
            result.forEach(function (ele) {
              if (e.grade == ele.grade) {
                grade_description.push(ele)
              }
            })
          })

          self.grade_description = grade_description
        })
        .catch(err => {
          console.log(err)

          if (err.response.status === 401) {
            self.$router.replace('/login')
          }
        })
    },
    selectResult (client_contact , column_id) {
      let self = this
      self.search = client_contact.full_name

      let dataObj = {}
      dataObj.full_name = client_contact.full_name
      dataObj.id = client_contact.uuid

      for (const property in self.opportunity_field_datas) {
        self.opportunity_field_datas[column_id].value = dataObj
      }

      // console.log("SLEEE res" , self.opportunity_field_datas)
    },

    updatePrimaryDdi (v, field_name) {
      this.core_field_datas[field_name].forEach(function (m) {
        m.is_primary = false

        if (m.ddi == v.ddi) {
          m.is_primary = true
        }
      })

      this.ddis.forEach(function (m) {
        m.is_primary = false

        if (m.ddi == v.ddi) {
          m.is_primary = true
        }
      })
    },
    updatePrimaryEmail (v, field_name) {
      this.core_field_datas[field_name].forEach(function (m) {
        m.is_primary = false

        if (m.email == v.email) {
          m.is_primary = true
        }
      })

      this.emails.forEach(function (m) {
        m.is_primary = false

        if (m.email == v.email) {
          m.is_primary = true
        }
      })
    },
    updatePrimarySocialMedia (v, field_name) {
      this.core_field_datas[field_name].forEach(function (m) {
        m.is_primary = false

        if (m.social_media == v.social_media) {
          m.is_primary = true
        }
      })

      this.social_medias.forEach(function (m) {
        m.is_primary = false

        if (m.social_media == v.social_media) {
          m.is_primary = true
        }
      })
    },
    updatePrimaryMobile (v, field_name) {
      this.core_field_datas[field_name].forEach(function (m) {
        m.is_primary = false

        if (m.mobile == v.mobile) {
          m.is_primary = true
        }
      })

      this.mobiles.forEach(function (m) {
        m.is_primary = false

        if (m.mobile == v.mobile) {
          m.is_primary = true
        }
      })
    },
    getSDViewLists () {
      let self = this
      let data = {}
      data.campaign_id = self.$route.params.campaignId
      data.sales_developer_id = self.user_id
      self.$store
        .dispatch('campaignsManagement/getSDViewLists', data)
        .then(res => {
          if (res) {
            self.sd_view_options = res.data

            self.sd_view_options.forEach(function (e) {
              if (e.is_default_view) {
                self.selected_view_for_sd = e
              }
            })
          }
        })
        .catch(err => {
          console.error(err)
        })
    },
    submitSaveViewAction () {
      let self = this
      let data = {}
      data.name = self.save_view_name
      data.description = self.save_view_description
      data.campaign_id = self.campaignId
      data.campaign_name = atob(self.$route.params.campaignName)
      data.sales_developer_id = self.user_id
      data.account_view = this.$refs.SDQCAccount.gridApi.getColumnState()
      data.contact_view = this.$refs.SDQCContact.gridApi.getColumnState()
      data.account_filter = this.$refs.SDQCAccount.gridApi.getFilterModel()
      data.contact_filter = this.$refs.SDQCContact.gridApi.getFilterModel()

      if (self.save_view_name != null) {
        self.$store
          .dispatch('campaignsManagement/submitSaveViewAction', data)
          .then(res => {
            if (res) {
              if (res.data.status == 'success') {
                self.getAccountDataSource()
                self.$refs.SDQCContact.gridApi.refreshServerSide({
                  purge: false
                })
                self.showHideSaveViewPopUp = false
                self.selected_status = null
                self.getSDViewLists()
              }
            }
          })
          .catch(err => {
            console.log(err)
          })
      }
    },
    saveViewPopup () {
      this.showHideSaveViewPopUp = true
      // console.log("Account COLUMNSTATE" , this.$refs.SDQCAccount.gridApi.getColumnState())

      // console.log("Contact COLUMNSTATE" , this.$refs.SDQCContact.gridApi.getColumnState())
    },
    viewOpportunities () {
      this.$router.push({
        path:
          '/views/sd_campaign_view/sales_developer_opportunities/' +
          this.$route.params.campaignId +
          '/' +
          this.$route.params.campaignName +
          '/' +
          this.$route.params.sd_user_id +
          '/' +
          this.$route.params.sd_user_full_name
      })

      // this.$router.push({
      //   path: '/sales_developer_opportunities/' + this.campaignId
      // })
    },
    showAccountTagFilter () {
      this.fetchAllAccountTagsWithSalesDeveloperId()
      this.showAccountTagFilterOption = !this.showAccountTagFilterOption
    },
    showContactTagFilter () {
      this.fetchAllContactTagsWithSalesDeveloperId()
      this.showContactTagFilterOption = !this.showContactTagFilterOption
    },
    submitStatusAction () {
      let self = this
      let data = {}

      if (self.selected_status == null) {
        self.please_choose_status = 'Please select status to update'
        return false
      }

      if (self.selected_status_notes == null) {
        self.please_choose_status_notes = 'Please select status notes to update'
        return false
      }

      let newAccountSubStatusArray = []

      if (self.selected_account_sub_status.length != 0) {
        for (let i = 0; i < self.selected_account_sub_status.length; i++) {
          newAccountSubStatusArray.push(self.selected_account_sub_status[i].uuid)
        }
        newAccountSubStatusArray = JSON.stringify(newAccountSubStatusArray)
      }
      else{
        newAccountSubStatusArray = null
      }

      let newContactSubStatusArray = []

      if (self.selected_contact_sub_status.length != 0) {
        for (let i = 0; i < self.selected_contact_sub_status.length; i++) {
          newContactSubStatusArray.push(self.selected_contact_sub_status[i].uuid)
        }
        newContactSubStatusArray = JSON.stringify(newContactSubStatusArray)
      }
      else{
        newContactSubStatusArray = null
      }



      let newArray = []
      newArray.push(this.selected_account_contact_status_data.table_id)
      data.table_ids = Array.from(newArray, x => `${x}`)

      if (this.selected_account_contact_status_data.hasOwnProperty('acc_id')) {
        data.level = 'account'
        data.account_status = self.selected_status.status
                data.account_sub_status = newAccountSubStatusArray
        data.account_status_notes = self.selected_status_notes
      } else {
        data.level = 'contact'
        data.contact_status = self.selected_status.status
                data.contact_sub_status = newContactSubStatusArray
        data.contact_status_notes = self.selected_status_notes
      }

      data.campaign_id = self.campaignId
      data.campaign_name = atob(self.$route.params.campaignName)
      data.sales_developer_id = self.user_id

      if (newArray.length != 0 && self.campaignId != null) {
        self.$store
          .dispatch('campaignsManagement/updateStatusToSDAccount', data)
          .then(res => {
            if (res) {
              if (res.data.status == 'success') {
                self.getAccountDataSource()
                self.$refs.SDQCContact.gridApi.refreshServerSide({
                  purge: false
                })
                self.showHideAccountStatusPopUp = false
                self.showHideContactStatusPopUp = false
                self.selected_status = null
                self.selected_status_notes = null
                 self.selected_account_sub_status = []
                 self.selected_contact_sub_status = []
                self.account_sub_statuses = []
                self.contact_sub_statuses = []
              }
            }
          })
          .catch(err => {
            console.log(err)
          })
      }
    },
    submitAccountTagAction () {
      let self = this
      let data = {}
      data.level = 'account'
      data.selected_account_tag_ids = self.selected_account_tag
      let newArray = []
      newArray.push(this.selected_account_tag_data.table_id)
      data.table_ids = Array.from(newArray, x => `${x}`)
      data.campaign_id = self.campaignId
      data.campaign_name = atob(self.$route.params.campaignName)
      data.sales_developer_id = self.user_id

      if (data.selected_account_tag_ids.length == 0) {
        self.please_account_choose_tag = 'Please select tag to update'
      }

      if (newArray.length != 0 && self.campaignId != null) {
        self.$store
          .dispatch('campaignsManagement/updateTagToSDAccount', data)
          .then(res => {
            if (res) {
              if (res.data.status == 'success') {
                self.getAccountDataSource()
                self.$refs.SDQCContact.gridApi.refreshServerSide({
                  purge: false
                })
                self.getContactDataSource()
                self.showTagAccountPopUp = false
              }
            }
          })
          .catch(err => {
            console.log(err)
          })
      }
    },
    submitContactTagAction () {
      let self = this
      let data = {}
      data.level = 'contact'
      data.selected_contact_tag_ids = self.selected_contact_tag
      let newArray = []
      newArray.push(this.selected_contact_tag_data.table_id)
      data.table_ids = Array.from(newArray, x => `${x}`)
      data.campaign_id = self.campaignId
      data.campaign_name = atob(self.$route.params.campaignName)
      data.sales_developer_id = self.user_id

      if (data.selected_contact_tag_ids.length == 0) {
        self.please_contact_choose_tag = 'Please select tag to update'
      }

      if (newArray.length != 0 && self.campaignId != null) {
        self.$store
          .dispatch('campaignsManagement/updateTagToSDAccount', data)
          .then(res => {
            if (res) {
              if (res.data.status == 'success') {
                self.getAccountDataSource()
                                self.$refs.SDQCContact.gridApi.refreshServerSide({
                  purge: false
                })
                self.getContactDataSource()
                self.showTagContactPopUp = false
              }
            }
          })
          .catch(err => {
            console.log(err)
          })
      }
    },
    fetchAllAccountTagsWithSalesDeveloperId () {
      this.$store
        .dispatch(
          'TagsManagement/fetchAllTagsWithSalesDeveloperId',
          this.sales_developer_id
        )
        .then(res => {
          let result = res.data
          result = result.filter(ele => ele.type == 'account')
          this.all_account_tags = result
        })
        .catch(err => {
          console.error(err)
        })
    },
    fetchAllContactTagsWithSalesDeveloperId () {
      this.$store
        .dispatch(
          'TagsManagement/fetchAllTagsWithSalesDeveloperId',
          this.sales_developer_id
        )
        .then(res => {
          let result = res.data
          result = result.filter(ele => ele.type == 'contact')
          this.all_contact_tags = result
        })
        .catch(err => {
          console.error(err)
        })
    },
    showAccountTagPopUp (data) {
      this.selected_account_tag = data.tag_ids
      this.fetchAllAccountTagsWithSalesDeveloperId()
      this.showTagAccountPopUp = true
      this.selected_account_tag_data = data
    },
    showContactTagPopUp (data) {
      this.selected_contact_tag = data.tag_ids
      this.fetchAllContactTagsWithSalesDeveloperId()
      this.showTagContactPopUp = true
      this.selected_contact_tag_data = data
    },
    fetchAllSDStatus () {
      this.$store
        .dispatch('campaignsManagement/fetchAllSDStatus')
        .then(res => {
          let result = res.data
          this.all_sd_status = result
        })
        .catch(err => {
          console.error(err)
        })
    },
    showAccountStatusPopUp (data) {
  let self = this
      self.selected_status = null
      self.selected_status_notes = null
        self.selected_account_sub_status = []
        self.selected_contact_sub_status = []
      self.account_sub_statuses = []
      self.contact_sub_statuses = []


      this.fetchAllSDStatus()
    
      this.showHideAccountStatusPopUp = true
      this.showHideContactStatusPopUp = false
      this.selected_account_contact_status_data = data
    },
    showContactStatusPopUp (data) {
        let self = this
      self.selected_status = null
      self.selected_status_notes = null
        self.selected_account_sub_status = []
        self.selected_contact_sub_status = []
      self.account_sub_statuses = []
      self.contact_sub_statuses = []
      this.fetchAllSDStatus()
      this.showHideContactStatusPopUp = true
      this.showHideAccountStatusPopUp = false
      this.selected_account_contact_status_data = data
    },
    addAccountTags () {
      this.$router.push({
        path:
          '/views/all_sd_campaign_view/assign_account_tag/' +
          this.$route.params.campaignId +
          '/' +
          this.$route.params.campaignName
      })
      // alert("add account tags")
    },
    addAccountStatus () {
      this.$router.push({
        path:
          '/views/all_sd_campaign_view/assign_account_status/' +
          this.$route.params.campaignId +
          '/' +
          this.$route.params.campaignName
      })
    },

    addContactStatus () {
      this.$router.push({
        path:
          '/views/all_sd_campaign_view/assign_contact_status/' +
          this.$route.params.campaignId +
          '/' +
          this.$route.params.campaignName
      })
    },
    addContactTags () {
      // alert(this.selected_campaign.campaign_name)
      this.$router.push({
        path:
          '/views/all_sd_campaign_view/assign_contact_tag/' +
          this.$route.params.campaignId +
          '/' +
          this.$route.params.campaignName
      })

      // alert("add contact tags")
    },
    getContactColumnData (contact_id) {
      let self = this
      let data = {}
      data.contact_id = contact_id
      data.campaign_id = self.campaignId
      self.selectedEditCampaignId = self.campaignId
      self.sales_developer_id = self.user_id
      self.selectedEditContactId = contact_id

      self.$store
        .dispatch('accountsManagement/getSDfetchContact', data)
        .then(res => {
          if (res.data) {
            self.editSelectedContact = JSON.parse(res.data)




            Object.keys(self.editSelectedContact).forEach(function (key) {







let campaign_data_options = self.editSelectedContact['campaign_data_options']

campaign_data_options.forEach(function (ele) {



  if (ele.identifier == 'none_core_field' && ele.type == 'checkbox' && ele.column_id == key  && ele.level == 'contact') {



   if (self.editSelectedContact[key] == null) {
  self.editSelectedContact[key] = []
}




if (typeof self.editSelectedContact[key] === 'string' || self.editSelectedContact[key] instanceof String) {
  


  if (self.editSelectedContact[key].startsWith('[') && self.editSelectedContact[key] != '[]') {
  
  
  
  
    self.editSelectedContact[key] = JSON.parse(self.editSelectedContact[key])
  
  
  
  
  
  
  }
  
  
  
  
  
  }









  }



  if (ele.identifier == 'none_core_field' && ele.type == 'textarea' && ele.column_id == key  && ele.level == 'contact') {

if(self.editSelectedContact[key] == null){
  self.editSelectedContact[key] = ''
}


}

})




})

          
          }
        })
        .catch(err => {
          console.error(err)
        })

      // var array = ["id","acc_id","campaign_id","contact_campaign_id","contact_id","contact_status","contact_id", "contact_status","contact_web"];
      // this.editSelectedContact = this.deleteKeys(contact, array);
      // console.log("Contact", this.editSelectedContact);
    },
    getAccountColumnData (account_id) {
      let self = this
      let data = {}
      data.account_id = account_id
      data.campaign_id = self.campaignId
      self.selectedEditCampaignId = self.campaignId
      self.selectedEditAccountId = account_id
      self.sales_developer_id = self.user_id


      self.$store
        .dispatch('accountsManagement/getSDfetchAccount', data)
        .then(res => {
          if (res.data) {
            self.editSelectedAccount = JSON.parse(res.data)





            Object.keys(self.editSelectedAccount).forEach(function (key) {







let campaign_data_options = self.editSelectedAccount['campaign_data_options']

campaign_data_options.forEach(function (ele) {



  if (ele.identifier == 'none_core_field' && ele.type == 'checkbox' && ele.column_id == key  && ele.level == 'account') {



   if (self.editSelectedAccount[key] == null) {
  self.editSelectedAccount[key] = []
}




if (typeof self.editSelectedAccount[key] === 'string' || self.editSelectedAccount[key] instanceof String) {
  


  if (self.editSelectedAccount[key].startsWith('[') && self.editSelectedAccount[key] != '[]') {
  
  
  
  
    self.editSelectedAccount[key] = JSON.parse(self.editSelectedAccount[key])
  
  
  
  
  
  
  }
  
  
  
  
  
  }









  }

  if (ele.identifier == 'none_core_field' && ele.type == 'textarea' && ele.column_id == key  && ele.level == 'account') {

if(self.editSelectedAccount[key] == null){
  self.editSelectedAccount[key] = ''
}


}

})




})
            



          
          }
        })
        .catch(err => {
          console.error(err)
        })
    },
    submitAndShowNextStep (submittedStepId) {
      let self = this

      // self.editSDAccountPopUp = false;
      //   self.getAllOpportunityFields()
      //   self.showOpportunitiesPopUp = true;

      self.selected_grade_steps.sort((a, b) => a.order_by - b.order_by)
      if (self.selected_grade_steps.length !== 1) {
        self.selected_grade_steps = self.selected_grade_steps.filter(
          ele => ele.grade_step_id != submittedStepId
        )
        self.step_by_step_grade_steps = self.selected_grade_steps[0]
      } else {
        self.updateSDAccountFromGradeSteps()
        self.updateSDContactFromGradeSteps()
        self.editSDAccountPopUp = false
        self.getAllOpportunityFields()


        if (self.showOpportunityPopUpFromGrade) {
      
          self.getContactOpportunities()
        } else {
          self.showOpportunitiesPopUp = false
          self.selectedDialAccountContact = null
          self.auditTrialSelectedContact = null
          self.selected_account_contact = null
          // self.selectedEditContactId = null
          // self.selectedEditAccountId = null
        }


      
        self.showOpportunityPopUpFromGrade = false
        this.getSDContactSelectedFields();
        this.getSDAccountSelectedFields();

        // document.getElementById("text_editor").classList.add("text_box");

        // self.getSDViewLists()
      }
    },
    getContactOpportunities(){
      let self = this
      let data = {}
      data.campaign_id = self.selectedEditCampaignId
      data.contact_id = self.selectedEditContactId
      data.account_id = self.selected_account_id
      self.$store
        .dispatch('campaignsManagement/getContactOpportunities', data)
        .then(res => {
         let response_data = JSON.parse(res.data)


           if(response_data.length > 0){






            

            let last_opp = response_data[0].opportunity




            if (typeof last_opp === 'string' || last_opp instanceof String) {


                  if (last_opp.startsWith('[') && last_opp != '[]') {
                    

                    last_opp = JSON.parse(last_opp)



                    self.last_opportunity = last_opp.toString()

                  }





                  }


            
             self.showOpportunityExistsPopup = true
           }else{
             self.showOpportunitiesPopUp = true

           }
        })
        .catch(err => {
          console.error(err)
        })

    },
    createOpportunity () {
      let self = this
      self.showGradeStepsPopUp = false
      self.getAllOpportunityFields()
      self.showOpportunitiesPopUp = true
    },
    createAnotherOpportunity () {
      let self = this
      this.showOpportunitiesPopUp = false
      self.componentKey += 1

      self.search = null

      this.showOpportunitiesPopUp = true

      let updateData = {}
      updateData.opportunity_field_datas = self.opportunity_field_datas

      updateData.campaign_id = self.selectedEditCampaignId



      if (self.selectedEditContactId == null) {
        self.selectedEditContactId = this.selected_contact_aggrid_node.data.contact_id
      }


      if (self.selected_account_id == null) {
        self.selected_account_id = this.selected_contact_aggrid_node.data.account_id
      }



      updateData.contact_id = self.selectedEditContactId
      updateData.account_id = self.selected_account_id



      updateData.sales_developer_id = self.user_id
      for (const property in self.opportunitiesCheckedFields) {
        if (self.opportunitiesCheckedFields[property] == '') {
          delete self.opportunitiesCheckedFields[property]
        }
      }
      updateData.checkbox_columns = self.opportunitiesCheckedFields
      self.updateOpportunitiesToDB(updateData)

      // self.showOpportunitiesPopUp = true;
    },
    submitOpportunityValues () {
      let self = this
      let updateData = {}
      updateData.opportunity_field_datas = self.opportunity_field_datas

      updateData.campaign_id = self.selectedEditCampaignId


      if (self.selectedEditContactId == null) {
        self.selectedEditContactId = this.selected_contact_aggrid_node.data.contact_id
      }


      if (self.selected_account_id == null) {
        self.selected_account_id = this.selected_contact_aggrid_node.data.account_id
      }



      updateData.contact_id = self.selectedEditContactId
      updateData.account_id = self.selected_account_id





      updateData.sales_developer_id = self.user_id
      for (const property in self.opportunitiesCheckedFields) {
        if (self.opportunitiesCheckedFields[property] == '') {
          delete self.opportunitiesCheckedFields[property]
        }
      }
      updateData.checkbox_columns = self.opportunitiesCheckedFields
      self.updateOpportunitiesToDB(updateData)

      self.showOpportunitiesPopUp = false

      self.$refs.SDQCAccount.gridApi.refreshCells({
        force: true
      })
      self.$refs.SDQCContact.gridApi.refreshCells({
        force: true
      })

      self.refreshAuditTrial()


      self.selectedDialAccountContact = null
        self.auditTrialSelectedContact = null
        self.selected_account_contact = null
        self.selectedEditContactId = null
        self.selectedEditAccountId = null

      //   self.$router.go(0);
    },
    updateOpportunitiesToDB (data) {
      let self = this
      self.$store
        .dispatch('campaignsManagement/updateSDOpportunity', data)
        .then(res => {
          self.$vs.notify({
            color: 'success',
            title: 'Opportunities',
            text: 'The opportunities was created successfully.'
          })

          self.getAllOpportunityFields()
        })
        .catch(err => {
          console.error(err)
        })
    },
    updateSDAccountFromGradeSteps () {

      



      
let updateData = {}
updateData.campaign_id = this.selectedEditCampaignId
updateData.account_id = this.selectedEditAccountId
updateData.all_field_datas = this.editSelectedAccount
updateData.account_status = this.selected_account_status
updateData.contact_status = this.selected_contact_status
updateData.account_table_id = this.selected_account_table_id
updateData.contact_table_id = this.selected_contact_table_id
updateData.sales_developer_id = this.user_id
// updateData.updated_by_admin = 'yes'


for (const property in this.checkedFields) {

if (this.checkedFields[property] == '' || this.checkedFields[property] == null) {
this.checkedFields[property] = []
}
}

updateData.checkbox_columns = this.checkedFields
let self = this

this.$store
  .dispatch('accountsManagement/updateSDQCAccount', updateData)
  .then(res => {
    this.showGradeStepsPopUp = false

    let response_data = res.data

    if (response_data.status == 'success') {
      this.$vs.notify({
        color: response_data.status,
        title: response_data.title,
        text: response_data.message
      })
    }



  
    self.$refs.SDQCContact.gridApi.clearFocusedCell()

    var get_selected_nodes = self.$refs.SDQCAccount.gridApi.getSelectedNodes()

    if(get_selected_nodes.length == 0){
            return false
          }


    get_selected_nodes[0].data = JSON.parse(response_data.data)
    self.$refs.SDQCAccount.gridApi.refreshCells({
      rowNodes: [get_selected_nodes[0]],
      force: true
    })


    var focusedCell = self.$refs.SDQCAccount.gridApi.getSelectedNodes()
    let selected_row_index = focusedCell[0].rowIndex
    let page_index = Math.floor(selected_row_index / self.$refs.SDQCAccount.gridApi.paginationGetPageSize())
    self.$refs.SDQCAccount.gridApi.paginationGoToPage(page_index)


    // for (
    //               let i = 0;
    //               i < self.$refs.SDQCAccount.gridApi.getDisplayedRowCount();
    //               i++
    //             ) {
    //               let node = self.$refs.SDQCAccount.gridApi.getDisplayedRowAtIndex(i)

    //               console.log(node.data)

    //               // node.data = response_data.data

    //               // self.$refs.SDQCAccount.gridApi.refreshCells({
    //               //   rowNodes: [node],
    //               //   force: true
    //               // })
    //             }

    // this.$refs.SDQCAccountFieldRef.gridApi.refreshServerSide({purge:false});
    // this.getSDAccountSelectedFields();

    // this.$refs.SDQCAccount.gridApi.refreshServerSide({purge:false});
    // this.getAccountDataSource();
    // this.$refs.SDQCContact.gridApi.refreshServerSide({purge:false});
    // this.getContactDataSource();

   
  })
  .catch(err => {
    console.log(err)
    if (err.response.status === 401) {
      this.$router.replace('/login')
    }
  })
},
updateSDContactFromGradeSteps () {
let updateData = {}
updateData.all_contact_field_datas = this.editSelectedContact
updateData.campaign_id = this.selectedEditCampaignId
updateData.contact_id = this.selectedEditContactId
updateData.account_status = this.selected_account_status
updateData.contact_status = this.selected_contact_status
updateData.account_table_id = this.selected_account_table_id
updateData.contact_table_id = this.selected_contact_table_id
updateData.account_id = this.selected_account_id
updateData.sales_developer_id = this.user_id
// updateData.updated_by_admin = 'yes'

let self = this

// for (const property in this.checkedFields) {

// if (this.checkedFields[property] == '' || this.checkedFields[property] == null) {
// this.checkedFields[property] = []
// }
// }

// updateData.checkbox_columns = this.checkedFields

self.$store
  .dispatch('accountsManagement/updateSDQCContact', updateData)
  .then(res => {
    // this.selectedEditCampaignId = null;
    // this.selectedEditContactId = null;

    if (!self.showOpportunityPopUpFromGrade) {
      self.showGradeStepsPopUp = false
      // self.$router.go(0);
    }

    let response_data = res.data

    if (response_data.status == 'success') {
      self.$vs.notify({
        color: response_data.status,
        title: response_data.title,
        text: response_data.message
      })
    }

    this.selected_contact_aggrid_node.data = JSON.parse(response_data.data)



    self.$refs.SDQCContact.gridApi.refreshCells({
      rowNodes: [self.selected_contact_aggrid_node],
      force: true
    })
    self.getDialCounts(
      self.selected_contact_aggrid_node.data.new_contact_id
    )

    self.refreshAuditTrial()
  })
  .catch(err => {
    console.error(err)
  })
},
    getAllGradeStepsByGradeId (grade) {
      let gradeDesc = {}
      gradeDesc.campaign_id = this.campaignId
      gradeDesc.grade_id = grade.id

      let self = this
      self.$store
        .dispatch('campaignsManagement/getAllGradeStepsByGradeId', gradeDesc)
        .then(response => {
          self.selected_grade_steps = JSON.parse(response.data)
          self.selected_grade_steps.sort((a, b) => a.order_by - b.order_by)

          if (self.selected_grade_steps) {
            self.step_by_step_grade_steps = self.selected_grade_steps[0]
          }
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace('/login')
          }
        })
    },
    fetchCampaignAssociatedClientContact () {
      let self = this
      this.$store
        .dispatch(
          'elomarkUsersManagement/fetchCampaignAssociatedClientContact',
          this.$route.params.campaignId
        )
        .then(res => {
          self.campaign_client_contacts =
            moduleElomarkUserManagement.state.campaign_associated_client_contact
          self.campaign_client_contacts.map(function (ele) {
            ele.full_name = ele.first_name + ' ' + ele.surname
          })
        })
        .catch(err => {
          console.log(err)
        })
    },
    getAllOpportunityFields () {
      let data = {}
      data.contact_id = this.selectedEditContactId
      data.account_id = this.selected_account_id
      data.campaign_id = this.campaignId
      data.grade_id = this.grades.grade.grade
      let self = this
      self.opportunitiesCheckedFields = {}
      self.$store
        .dispatch('campaignsManagement/getAllOpportunityFields', data)
        .then(res => {
          if (res.data) {
            let result = JSON.parse(res.data)
            self.opportunity_field_options = result[0]['options']
            self.opportunity_field_datas = result[0]['data']
            let new_opportunity_field_values = {}
            self.opportunity_field_options.forEach(function (ele) {
              Object.entries(self.opportunity_field_datas).forEach(
                ([key, value]) => {
                  if (key == ele.column_id) {
                    let json_value = null

                    try {
                      json_value = JSON.parse(value)
                    } catch (e) {
                      json_value = value
                    }

                    if (json_value != null) {
                      if (json_value.length == 1) {
                        json_value = json_value[0]
                      }

                      new_opportunity_field_values[key] = {
                        value: json_value,
                        type: ele.type,
                        options: ele.values,
                        model: key
                      }
                    } else {
                      new_opportunity_field_values[key] = {
                        value: json_value,
                        type: ele.type,
                        options: ele.values,
                        model: key
                      }
                    }
                  }
                }
              )
            })

            self.opportunity_field_datas = new_opportunity_field_values

            for (const property in self.opportunity_field_datas) {


              if (self.opportunity_field_datas[property].type == 'checkbox') {
                let new_key_name = self.opportunity_field_datas[property]
                if (!Array.isArray(new_key_name.value)) {
                  new_key_name.value = [new_key_name.value]
                }
                self.opportunitiesCheckedFields[new_key_name.model] =
                  new_key_name.value
              }


              if (self.opportunity_field_datas[property].type == 'textarea') {
               
                   if (self.opportunity_field_datas[property].value == null) {
                    self.opportunity_field_datas[property].value = ''

                   }

              }





            }
          }
        })
        .catch(err => {
          console.log(err)
          if (err.response.status === 401) {
            this.$router.replace('/login')
          }
        })
    },
    openGradeStepsPopUp () {
      let self = this

      let data = {}
      data.campaign_id = this.campaignId
      data.selected_grade = self.grades.grade.grade
      data.sales_developer_id = self.user_id

      if (self.selected_account_contact != null) {
        data.contact_id = self.selected_account_contact.contact_id
        data.account_id = self.selected_account_contact.account_id
      } else {
        data.contact_id = self.auditTrialSelectedContact.contact_id
        data.account_id = self.auditTrialSelectedContact.account_id
      }

      if (data.contact_id == null && data.account_id == null) {
        data.contact_id = self.selected_contact_aggrid_node.contact_id
        data.account_id = self.selected_contact_aggrid_node.account_id
      }

      if (self.audit_trial_with_dial.outcome != null) {
        data.action_type_id =
          self.audit_trial_with_dial.outcome.call_action_type_id
        data.outcome_id = self.audit_trial_with_dial.outcome.id
        data.notes = self.audit_trial_with_dial.notes
        data.date_time = self.audit_trial_with_dial.date_time
      } else {
        data.action_type_id = self.audit_trial.action_type.id
        data.outcome_id = self.audit_trial.outcome.id
        data.notes = self.audit_trial.notes
        data.date_time = self.audit_trial.date_time
      }

      // if(self.audit_trial_with_dial.action_type != null){

      //   data.action_type_id = self.audit_trial_with_dial.action_type.id;
      // data.outcome_id = self.audit_trial_with_dial.outcome.id;
      // data.notes = self.audit_trial_with_dial.notes;
      // data.date_time = self.audit_trial_with_dial.date_time;

      // }
      // else{
      //   data.action_type_id = self.audit_trial.action_type.id;
      // data.outcome_id = self.audit_trial.outcome.id;
      // data.notes = self.audit_trial.notes;
      // data.date_time = self.audit_trial.date_time;
      // }

      self.$store
        .dispatch('campaignsManagement/updateSelectedGradeOnSDContact', data)
        .then(res => {
          if (res) {
            let result = res.data
            if (result.data) {
              self.showOpportunityPopUpFromGrade = true
            }
          }
          self.AuditTrialPopupActive = false
          self.AuditTrialWithDialPopupActive = false
          self.showSchedulePopUp = false
          self.showGradePopUp = false
          self.showGradeStepsPopUp = true
        })
        .catch(err => {
          console.error(err)
        })

      if (self.selected_account_contact != null) {
        self.getAccountColumnData(self.selected_account_contact.account_id)
        self.getContactColumnData(self.selected_account_contact.contact_id)
        self.selected_contact_table_id = self.selected_account_contact.table_id
        self.selected_account_table_id = self.selected_account_contact.id
        self.selected_contact_status =
          self.selected_account_contact.contact_status
        self.selected_account_status =
          self.selected_account_contact.account_status
        self.selected_account_id = self.selected_account_contact.account_id
      } else {
        self.getAccountColumnData(self.auditTrialSelectedContact.account_id)
        self.getContactColumnData(self.auditTrialSelectedContact.contact_id)
        self.selected_contact_table_id = self.auditTrialSelectedContact.table_id
        self.selected_account_table_id = self.auditTrialSelectedContact.id
        self.selected_contact_status =
          self.auditTrialSelectedContact.contact_status
        self.selected_account_status =
          self.auditTrialSelectedContact.account_status
        self.selected_account_id = self.auditTrialSelectedContact.account_id
      }

      self.getAllGradeStepsByGradeId(self.grades.grade)
    },
    getAllGradesByCampaignId () {
      let data = {}




      if (this.selectedDialAccountContact != null) {
        data.account_id = this.selectedDialAccountContact.account_id
        data.contact_id = this.selectedDialAccountContact.contact_id
      } else {
        data.contact_id = this.auditTrialSelectedContact.contact_id
        data.account_id = this.auditTrialSelectedContact.account_id
      }



      data.campaign_id = this.campaignId

      this.$store
        .dispatch('GradesManagement/getAllGradesByCanBeChangedBySD', data)
        .then(res => {
          this.grade_options = res.data

          // this.grade_options = this.grade_options.filter(ele => ele.grade != '2')
          this.grade_options.sort((a, b) => a.grade - b.grade)

          this.getCampaignGrades(this.campaignId)
        })
        .catch(err => {
          console.error(err)
        })
    },
    dialNext () {
      let self = this
      self.grade_options = []

      self.grades.grade = null
      self.AuditTrialPopupActive = false
      self.AuditTrialWithDialPopupActive = false
      self.showSchedulePopUp = false
      self.showGradePopUp = true
      self.search = ''

      self.getAllGradesByCampaignId()
    },
    addScheduleANextAction () {
      this.submitAuditTrialForm()
      this.showSchedulePopUp = true
    },
    scheduleANextAction () {
      this.addAuditTrialWithDial()
      this.showSchedulePopUp = true
    },
    addscheduleToCalendar () {
      let self = this
      self.schedule_a_next_action.sales_developer_id = self.user_id
      self.schedule_a_next_action.campaign_id = self.campaignId
      // self.audit_trial.action_type_id = self.audittrial_action_type_id;
      // self.audit_trial.outcome_id = self.audittrial_outcome_id;
      self.schedule_a_next_action.campaign_id = self.campaignId
      self.schedule_a_next_action.selected_account_contact =
        self.selected_contact_aggrid_node.data

      self.schedule_a_next_action.notes =
        '<p><strong>Company Name</strong> : ' +
        self.selected_contact_aggrid_node.data.company_name +
        '</p><p><strong>Contact Name</strong> : ' +
        self.selected_contact_aggrid_node.data._78540c9c_ce81_4ec0_8320_31838956392a +
        ' ' +
        self.selected_contact_aggrid_node.data._755c8e1e_1725_4653_93f6_b8a888f4a423 +
        ' </p><p><strong>Job Title</strong> : ' +
        self.selected_contact_aggrid_node.data._bd654e2e_a6c3_426a_8486_30e753088090 +
        ' </p><p><strong>Notes</strong> : new scheduled has been set to the calendar. </p><p><strong>URL</strong> : <a href=' +
        window.location.origin +
        '/views/all_sd_campaign_view/' +
        self.campaignId +
        '/' +
        btoa(self.campaignDescription.campaign_name) +
        '/' +
        btoa(self.selected_contact_aggrid_node.data._78540c9c_ce81_4ec0_8320_31838956392a) +
        '/' +
        btoa(self.selected_contact_aggrid_node.data._755c8e1e_1725_4653_93f6_b8a888f4a423) +
        '/' +
        btoa(self.selected_contact_aggrid_node.data._bd654e2e_a6c3_426a_8486_30e753088090) +
        " rel='noopener noreferrer' target='_blank'>" +
        window.location.origin +
        '/views/all_sd_campaign_view/' +
        self.campaignId +
        '/' +
        btoa(self.campaignDescription.campaign_name) +
        '/' +
        btoa(self.selected_contact_aggrid_node.data._78540c9c_ce81_4ec0_8320_31838956392a) +
        '/' +
        btoa(self.selected_contact_aggrid_node.data._755c8e1e_1725_4653_93f6_b8a888f4a423) +
        '/' +
        btoa(self.selected_contact_aggrid_node.data._bd654e2e_a6c3_426a_8486_30e753088090) +
        '</a></p><p><br></p><p><br></p>'

   
      self.$store
        .dispatch(
          'AuditTrialsManagement/addScheduleToCalendar',
          self.schedule_a_next_action
        )
        .then(function (response) {
          if (response.data.status == 'success') {
            self.$vs.notify({
              color: 'success',
              title: 'Scheduled Calendar',
              text: 'The schedule has been added to calendar successfully'
            })
            // self.schedule_a_next_action = {
            //   sales_developer_id: null,
            //   subject: null,
            //   start_date_time: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
            //   end_date_time: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
            //   campaign_id: null,
            //   notes: null,
            //   selected_account_contact: null
            // };
            self.AuditTrialPopupActive = false
            self.AuditTrialWithDialPopupActive = false
            self.showSchedulePopUp = false

            // self.$refs.SDQCAccount.gridApi.refreshServerSide({purge:false})
            // self.getAccountDataSource()
            // self.$refs.SDQCContact.gridApi.refreshServerSide({purge:false})
            // self.getContactDataSource()

            // self.$router.go(0);
            self.refreshAuditTrial()
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    noIdontToScheduleANextAction () {
      this.addAuditTrial()
    },
    closeAuditTrialWithDialPopup (value) {
      if (!value) this.AuditTrialWithDialPopupActive = true
    },
    closeshowSchedulePopup (value) {
      if (!value) this.showSchedulePopUp = true
    },
    closeshowGradePopup (value) {
      if (!value) this.showGradePopUp = true
    },
    closeshowOpportunityExistsPopup (value) {
      if (!value) this.showOpportunityExistsPopup = true
    },
    closeshowTagPopup (value) {
      if (!value) this.showTagAccountContactPopUp = true
    },
    closeshowGradeStepsPopup (value) {
      if (!value) this.showGradeStepsPopUp = true
    },
    closeshowOpportunitiesPopup (value) {
      if (!value) this.showOpportunitiesPopUp = true
    },
    fetchOptionsByActionTypeAndOutcome () {
      let self = this
      let data = {}
      data.action_type_id = this.audittrial_action_type_id
      data.outcome_id = this.audittrial_outcome_id

      this.$store
        .dispatch(
          'AuditTrialsManagement/fetchOptionsByActionTypeAndOutcome',
          data
        )
        .then(res => {
          let result = res.data
          self.optionDescription = result
          self.selected_options = self.optionDescription.option
        })
        .catch(err => {
          console.error(err)
        })
    },
    getDialAction () {
      this.$store
        .dispatch('AuditTrialsManagement/getDialAction')
        .then(res => {
          if (res) {
            this.dialAction = res.data
          }
        })
        .catch(err => {
          console.error(err)
        })
    },
    getAuditTrails (contact_id) {
      let data = {}
      data.campaign_id = this.campaignId
      data.contact_id = contact_id
      this.$store
        .dispatch('AuditTrialsManagement/getAuditTrials', data)
        .then(res => {
          if (res) {
            this.contactsAuditTrials = res.data
            this.contactsAuditTrials.forEach(function (ele) {
              ele.date_time = moment(ele.date_time).format(
                'MM/DD/YYYY hh:mm:ss'
              )
            })
          }
        })
        .catch(err => {
          console.error(err)
        })
    },
    getContactNotes (contact_id) {
      let data = {}
      data.campaign_id = this.campaignId
      data.contact_id = contact_id
      this.$store
        .dispatch('campaignsManagement/getContactNotes', data)
        .then(res => {
          if (res) {
            this.accountNotes = null
            this.contactNotes = JSON.parse(res.data)
          }
        })
        .catch(err => {
          console.error(err)
        })
    },
    getDialCounts (contact_id) {
      let data = {}
      data.campaign_id = this.campaignId
      data.contact_id = contact_id
      this.$store
        .dispatch('campaignsManagement/getDialCounts', data)
        .then(res => {
          if (res) {
            this.dial_counts = res.data
          }
        })
        .catch(err => {
          console.error(err)
        })
    },
    getAccountNotes (account_id) {
      let data = {}
      data.campaign_id = this.campaignId
      data.account_id = account_id
      this.$store
        .dispatch('campaignsManagement/getAccountNotes', data)
        .then(res => {
          if (res) {
            this.contactNotes = null
            this.accountNotes = JSON.parse(res.data)
          }
        })
        .catch(err => {
          console.error(err)
        })
    },
    auditTrialWithDialFunc (data) {
      this.selected_options = []
      this.dialPopupActive = false
      this.AuditTrialPopupActive = false
      this.auditTrialWithDial = true

      this.AuditTrialWithDialPopupActive = true

      // Needs to change
      let action_type_id = this.dialAction.action_type_id
      this.fetchAllOutcomesByActionType(action_type_id)
      this.audit_trial_with_dial.action_type_id = action_type_id
      this.audit_trial_with_dial.account_id =
        this.selectedDialAccountContact.account_id
      this.audit_trial_with_dial.contact_id =
        this.selectedDialAccountContact.contact_id

      this.submitAuditTrialWithDialForm()
    },
    submitAuditTrialWithDialForm () {
      this.addAuditTrialWithDial()
    },
    addAuditTrialWithDial () {
      let self = this
      this.audit_trial_with_dial.outcome_id =
        this.audit_trial_with_dial.outcome.id
      this.audit_trial_with_dial.grade =
        this.audit_trial_with_dial.outcome.grade

      this.audit_trial_with_dial.sales_developer_id = this.user_id
      this.audit_trial_with_dial.campaign_id = this.campaignId
      this.audit_trial_with_dial.date_time = moment(new Date()).format(
        'YYYY-MM-DD hh:mm:ss'
      )

      self.$store
        .dispatch(
          'AuditTrialsManagement/addAuditTrials',
          self.audit_trial_with_dial
        )
        .then(function (response) {
          if (response.data.status == 'success') {
            self.$vs.notify({
              color: 'success',
              title: 'Audit Trial Added',
              text: 'The audit trial was added successfully'
            })

            // self.audit_trial_with_dial = {
            //   outcome: null,
            //   notes: null
            // };
            self.AuditTrialWithDialPopupActive = false

            self.getAuditTrails(self.selectedDialAccountContact.contact_id)

            if (!self.showSchedulePopUp) {
              self.AuditTrialWithDialPopupActive = false

              // alert("Sdfsdfsdf")
              //  self.$router.go(0);
            }

            self.selected_contact_aggrid_node.data.grade = response.data.data

            self.$refs.SDQCContact.gridApi.refreshCells({
              rowNodes: [self.selected_contact_aggrid_node],
              force: true
            })

            self.getDialCounts(
              self.selected_contact_aggrid_node.data.new_contact_id
            )

            // self.$refs.SDQCAccount.gridApi.refreshServerSide({purge:false})
            // self.getAccountDataSource()
            // self.$refs.SDQCContact.gridApi.refreshServerSide({purge:false})
            // self.getContactDataSource()

            self.refreshAuditTrial()
          }
        })
        .catch(err => {
          console.log(err)
        })

      // console.log(self.audit_trial);
      // return false;
    },
    submitAuditTrialForm () {
      this.addAuditTrial()
    },
    refreshAuditTrial () {
      let self = this

      self.audit_trial_with_dial.action_type = null
      self.audit_trial_with_dial.outcome = null
      self.audit_trial_with_dial.action_type_id = null
      self.audit_trial_with_dial.outcome_id = null
      self.audit_trial_with_dial.grade = null
      self.audit_trial_with_dial.campaign_id = null
      self.audit_trial_with_dial.sales_developer_id = null
      self.audit_trial_with_dial.campaign_id = null
      self.audit_trial_with_dial.account_id = null
      self.audit_trial_with_dial.contact_id = null
      self.audit_trial_with_dial.notes = null

      self.audit_trial.action_type = null
      self.audit_trial.outcome = null
      self.audit_trial.action_type_id = null
      self.audit_trial.outcome_id = null
      self.audit_trial.grade = null
      self.audit_trial.campaign_id = null
      self.audit_trial.sales_developer_id = null
      self.audit_trial.campaign_id = null
      self.audit_trial.account_id = null
      self.audit_trial.contact_id = null
      self.audit_trial.notes = null

      self.schedule_a_next_action.subject = null
      self.schedule_a_next_action.notes = null
      self.schedule_a_next_action.selected_account_contact = null



      self.selectedDialAccountContact = null
        self.auditTrialSelectedContact = null
        self.selected_account_contact = null
        self.selectedEditContactId = null
        self.selectedEditAccountId = null


//
      // if (self.selectedDialAccountContact != null) {
      //   self.selectedDialAccountContact.account_id = null
      //   self.selectedDialAccountContact.contact_id = null
      // }

      // if (self.auditTrialSelectedContact != null) {
      //   self.auditTrialSelectedContact.account_id = null
      //   self.auditTrialSelectedContact.contact_id = null
      // }

      // self.selected_account_contact = null

      // self.selected_account_id = null
      // self.selected_contact_id = null
    },
    addAuditTrial () {
      let self = this
      self.audit_trial.sales_developer_id = self.user_id
      self.audit_trial.campaign_id = self.campaignId
      self.audit_trial.action_type_id = self.audittrial_action_type_id
      self.audit_trial.outcome_id = self.audittrial_outcome_id
      self.audit_trial.grade = self.audittrial_outcome_grade

      if (self.auditTrialSelectedContact == null) {
        self.audit_trial.account_id = self.audit_trial_with_dial.account_id
        self.audit_trial.contact_id = self.audit_trial_with_dial.contact_id
      } else {
        self.audit_trial.account_id = self.auditTrialSelectedContact.account_id
        self.audit_trial.contact_id = self.auditTrialSelectedContact.contact_id
        self.selected_account_contact = self.auditTrialSelectedContact
      }

      // if(self.audit_trial.account_id == null && self.audit_trial.contact_id == null){
      //   self.audit_trial.account_id = this.selected_contact_aggrid_node.data.account_id
      //   self.audit_trial.contact_id = this.selected_contact_aggrid_node.data.contact_id
      // }

      self.$store
        .dispatch('AuditTrialsManagement/addAuditTrials', self.audit_trial)
        .then(function (response) {
          if (response.data.status == 'success') {
            self.$vs.notify({
              color: 'success',
              title: 'Audit Trial Added',
              text: 'The audit trial was added successfully'
            })

            self.audit_trial = {
              date_time: moment(new Date()).format('YYYY-MM-DD hh:mm:ss'),
              outcome: null,
              notes: null,
              action_type: null,
              campaign_id: null,
              sales_developer_id: null,
              account_id: null,
              contact_id: null
            }
            self.AuditTrialPopupActive = false

            if (self.auditTrialSelectedContact == null) {
              self.getAuditTrails(self.audit_trial_with_dial.account_id)
            } else {
              self.getAuditTrails(self.auditTrialSelectedContact.contact_id)
            }

            self.AuditTrialWithDialPopupActive = false

            //  console.log("UPDATED Grade" , response.data.data )
            //  console.log("NODE" , self.selected_contact_aggrid_node)

            self.selected_contact_aggrid_node.data.grade = response.data.data

            self.$refs.SDQCContact.gridApi.refreshCells({
              rowNodes: [self.selected_contact_aggrid_node],
              force: true
            })

            self.getDialCounts(
              self.selected_contact_aggrid_node.data.new_contact_id
            )

            self.refreshAuditTrial()

            // self.$router.go(0);
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    fetchAllActionTypes () {
      var self = this
      self.$store
        .dispatch('OutcomesManagement/getAllActionTypesForOutcomes')
        .then(function (response) {
          let response_data = response.data
          self.action_types = response_data
        })
        .catch(err => {
          console.log(err)
        })
    },
    fetchAllOutcomesByActionType (action_type_id) {
      var self = this
      self.$store
        .dispatch(
          'OutcomesManagement/getAllOutcomesByActionype',
          action_type_id
        )
        .then(function (response) {
          let response_data = response.data
          self.outcomes = response_data
        })
        .catch(err => {
          console.log(err)
        })
    },
    updateQCNumbers () {
      let self = this
      let data = {}
      data.campaign_id = self.campaignId
      data.numbers = self.listofNumbers
      data.type = self.showDialTitle
      data.primary_mobile = self.primary_mobile
      data.primary_ddi = self.primary_ddi
      data.selected_account_contact = self.selectedDialAccountContact
      this.$store
        .dispatch('accountsManagement/updateQCNumbers', data)
        .then(res => {
          if (res.data.status == 'success') {
            self.$refs.SDQCContact.gridApi.refreshServerSide({ purge: false })
            self.showEditNumbers = false

            self.dialPopupActive = false
          }
        })
        .catch(err => {
          console.error(err)
        })
    },
    editNumbers () {
      this.showEditNumbers = true
    },
    dialNumber (data) {
      this.selected_contact_aggrid_node = data.params.node

      this.selected_account_contact = data.data
      this.selectedDialAccountContact = data.data

      this.selected_options = []
      this.audit_trial_with_dial.outcome = null
      this.audit_trial_with_dial.notes = null

      let dial_number = '0000000000'
      this.showDialTitle = data.type
      if (this.showDialTitle == 'ddi') {
        dial_number =
          data.data.contact_ddi[0].ddi_phone_code + data.data.contact_ddi[0].ddi
      }
      if (this.showDialTitle == 'mobile') {
        dial_number =
          data.data.contact_mobile[0].mobile_phone_code +
          data.data.contact_mobile[0].mobile
      }
      if (this.showDialTitle == 'switchboard') {
        dial_number = data.data._e4329196_efa0_417b_93a2_e12ec28ece85 + data.data.switchboard
      }
      if (this.showDialTitle == 'site_switchboard') {
        dial_number =
          data.data.site_switchboard_phone_code + data.data.site_switchboard
      }
      if (this.showDialTitle == 'other') {
        dial_number =
          data.data.account_phone[0].phone_code +
          data.data.account_phone[0].phone_no
      }

      dial_number = dial_number.replace(/[^\d.]/g, '')
      // window.open("sip:" + dial_number + "?call", "_blank");
      window.open('sip:' + dial_number)






      // this.$refs.SDQCContact.gridApi.refreshServerSide({purge:false})
      // this.getContactDataSource()
      this.AuditTrialPopupActive = false
      this.auditTrialWithDial = true

      this.AuditTrialWithDialPopupActive = true
      // Needs to change
      let action_type_id = this.dialAction.action_type_id
      this.fetchAllOutcomesByActionType(action_type_id)
      this.audit_trial_with_dial.action_type_id = action_type_id
      //here
      this.audit_trial_with_dial.account_id = data.data.account_id
      this.audit_trial_with_dial.contact_id = data.data.contact_id
    },
    showDialPopup (data) {
      this.selected_contact_aggrid_node = data.params.node

      let self = this
      this.showEditNumbers = false
      this.showDialTitle = data.type
      this.selectedDialAccountContact = data.data
      this.selected_account_contact = data.data

      // alert("sdfsdfsdf")
      //   console.log(data.data)

      if (this.showDialTitle == 'ddi') {
        this.listofNumbers = data.data.contact_ddi

        this.listofNumbers.forEach(function (ele) {
          ele.ddi = ele.ddi.replace(/[^\d.]/g, '')
          if (ele.is_primary == true) {
            self.primary_ddi = ele.ddi
          }
        })
      }
      if (this.showDialTitle == 'mobile') {
        this.listofNumbers = data.data.contact_mobile

        this.listofNumbers.forEach(function (ele) {
          ele.mobile = ele.mobile.replace(/[^\d.]/g, '')

          if (ele.is_primary == true) {
            self.primary_mobile = ele.mobile
          }
        })
      }
      if (this.showDialTitle == 'switchboard') {
        this.listofNumbers = data.data.switchboard
      }
      if (this.showDialTitle == 'site_switchboard') {
        this.listofNumbers = data.data.site_switchboard
      }
      if (this.showDialTitle == 'other') {
        this.listofNumbers = data.data.account_phone
        this.listofNumbers.forEach(function (ele) {
          ele.phone_no = ele.phone_no.replace(/[^\d.]/g, '')
        })
      }
      this.dialPopupActive = true
      this.auditTrialWithDial = true
    },
    getSubRole (role_id) {
      this.$store
        .dispatch('contactsManagement/getSubRoles', role_id)
        .then(res => {
          this.sub_roles = res.data
        })
        .catch(err => {
          console.error(err)
        })
    },
    checkOpportunitySelectedCheckboxField (e) {
      let self = this

      this.$nextTick(() => {
        for (const property in self.opportunitiesCheckedFields) {
          if (e.target.id === property) {
            if (self.opportunitiesCheckedFields[property] != null) {
              if (
                self.opportunitiesCheckedFields[property].includes(
                  e.target.value
                )
              ) {
                self.opportunitiesCheckedFields[property] =
                  self.opportunitiesCheckedFields[property].filter(function (
                    ele
                  ) {
                    return ele !== e.target.value
                  })
              } else {
                // alert(e.target.value)
                self.opportunitiesCheckedFields[property].push(e.target.value)
                // console.log(self.opportunitiesCheckedFields[property])

                if (self.opportunitiesCheckedFields[property].length != 0) {
                  self.opportunitiesCheckedFields[property] =
                    self.opportunitiesCheckedFields[property].filter(
                      x => x != null
                    )
                }
              }
            } else {
              self.opportunitiesCheckedFields[property] = []
              self.opportunitiesCheckedFields[property].push(e.target.value)

              if (self.opportunitiesCheckedFields[property].length != 0) {
                self.opportunitiesCheckedFields[property] =
                  self.opportunitiesCheckedFields[property].filter(
                    x => x != null
                  )
              }
            }
          }
        }
        return false
      })
    },
    checkSelectedCheckboxField (e) {

      let self = this

      this.$nextTick(() => {
        for (const property in self.checkedFields) {
          if (e.target.id === property) {
            if (self.checkedFields[property] != null) {
              if (self.checkedFields[property].includes(e.target.value)) {
                self.checkedFields[property] = self.checkedFields[
                  property
                ].filter(function (ele) {
                  return ele !== e.target.value
                })
              } else {
                // alert(e.target.value)
                self.checkedFields[property].push(e.target.value)
                // console.log(self.checkedFields[property])

                if (self.checkedFields[property].length != 0) {
                  self.checkedFields[property] = self.checkedFields[
                    property
                  ].filter(x => x != null)
                }
              }
            } else {
              self.checkedFields[property] = []
              self.checkedFields[property].push(e.target.value)

              if (self.checkedFields[property].length != 0) {
                self.checkedFields[property] = self.checkedFields[
                  property
                ].filter(x => x != null)
              }
            }
          }
        }
        return false
      })


    },
    getVerticals (inputValue) {
      return this.$store
        .dispatch('accountsManagement/getVerticals', inputValue)
        .then(response => {
          let data = response.data
          let mappedArray = []
          for (const property in data) {
            mappedArray.push({
              id: data[property].id,
              name: data[property].vertical
            })
          }
          return mappedArray
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace('/login')
          }
        })
    },
    getParentCompany (inputValue) {
      return this.$store
        .dispatch('accountsManagement/searchAutocomplete', inputValue)
        .then(response => {
          let data = JSON.parse(JSON.parse(JSON.stringify(response.data)))
          let mappedArray = []
          for (const property in data) {
            mappedArray.push({
              id: data[property].uuid,
              name: data[property].company_name
            })
          }
          return mappedArray
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace('/login')
          }
        })
    },
    editHeadOfficeCountry () {
      this.showHeadOfficeCountryField = false
      this.showHeadOfficeEditAutocomplete = true
      // console.log(this.$refs.EditHeadOfficeAutoComplete[0].$refs.suggestComponent);
      this.$refs.EditHeadOfficeAutoComplete[0].$refs.suggestComponent.isInFocus = true
      this.$refs.EditHeadOfficeAutoComplete[0].$refs.suggestComponent.isClicking = true
      // this.$refs.EditHeadOfficeAutoComplete.$refs.suggestComponent.input.value = this.accountDescription.head_office_country;
      // this.$refs.EditHeadOfficeAutoComplete.$refs.suggestComponent.value = this.accountDescription.head_office_country;
    },
    editSatelliteOfficeCountry () {
      this.showSatelliteOfficeCountryField = false
      this.showSatelliteOfficeEditAutocomplete = true
      // console.log(this.$refs.EditSatelliteOfficeAutoComplete[0].$refs.suggestComponent);
      this.$refs.EditSatelliteOfficeAutoComplete[0].$refs.suggestComponent.isInFocus = true
      this.$refs.EditSatelliteOfficeAutoComplete[0].$refs.suggestComponent.isClicking = true
      // this.$refs.EditSatelliteOfficeAutoComplete.$refs.suggestComponent.input.value = this.accountDescription.satellite_office_country;
      // this.$refs.EditSatelliteOfficeAutoComplete.$refs.suggestComponent.value = this.accountDescription.satellite_office_country;
    },
    editRegisteredOfficeCountry () {
      this.showRegisteredOfficeCountryField = false
      this.showRegisteredOfficeEditAutocomplete = true
      // console.log(this.$refs.EditRegisteredOfficeAutoComplete[0].$refs.suggestComponent);
      this.$refs.EditRegisteredOfficeAutoComplete[0].$refs.suggestComponent.isInFocus = true
      this.$refs.EditRegisteredOfficeAutoComplete[0].$refs.suggestComponent.isClicking = true
      // this.$refs.EditRegisteredOfficeAutoComplete.$refs.suggestComponent.input.value = this.accountDescription.registered_office_country;
      // this.$refs.EditRegisteredOfficeAutoComplete.$refs.suggestComponent.value = this.accountDescription.registered_office_country;
    },
    editRegistrationJurisdiction () {
      this.showRegistrationJurisdictionField = false
      this.showRegistrationJurisdictionEditAutocomplete = true
      // console.log(this.$refs.EditRegistrationJurisdictionAutoComplete[0].$refs.suggestComponent);
      this.$refs.EditRegistrationJurisdictionAutoComplete[0].$refs.suggestComponent.isInFocus = true
      this.$refs.EditRegistrationJurisdictionAutoComplete[0].$refs.suggestComponent.isClicking = true
      // this.$refs.EditRegistrationJurisdictionAutoComplete.$refs.suggestComponent.input.value = this.accountDescription.registered_office_country;
      // this.$refs.EditRegistrationJurisdictionAutoComplete.$refs.suggestComponent.value = this.accountDescription.registered_office_country;
    },
    editParent () {
      this.showParentField = false
      this.showParentEditAutocomplete = true
      // console.log(this.$refs.EditParentAutoComplete[0].$refs.suggestComponent);
      this.$refs.EditParentAutoComplete[0].$refs.suggestComponent.isInFocus = true
      this.$refs.EditParentAutoComplete[0].$refs.suggestComponent.isClicking = true
      // this.$refs.EditParentAutoComplete.$refs.suggestComponent.input.value = this.accountDescription.registered_office_country;
      // this.$refs.EditParentAutoComplete.$refs.suggestComponent.value = this.accountDescription.registered_office_country;
    },
    editVertical () {
      this.showVerticalField = false
      this.showVerticalEditAutocomplete = true
      // console.log(this.$refs.EditVerticalAutoComplete[0].$refs.suggestComponent);
      this.$refs.EditVerticalAutoComplete[0].$refs.suggestComponent.isInFocus = true
      this.$refs.EditVerticalAutoComplete[0].$refs.suggestComponent.isClicking = true
      // this.$refs.EditVerticalAutoComplete.$refs.suggestComponent.input.value = this.accountDescription.registered_office_country;
      // this.$refs.EditVerticalAutoComplete.$refs.suggestComponent.value = this.accountDescription.registered_office_country;
    },
    isValidJsonString (jsonString) {
      if (
        !(
          jsonString &&
          typeof jsonString === 'string' &&
          typeof jsonString === 'number'
        )
      ) {
        return false
      }

      try {
        JSON.parse(jsonString)
        return true
      } catch (error) {
        return false
      }
    },
    getSeniority () {
      this.$store
        .dispatch('contactsManagement/getSeniority')
        .then(res => {
          this.seniorities = res.data
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace('/login')
          }
        })
    },
    updateSDAccount () {


      let self = this


      let updateData = {}
      updateData.all_field_datas = this.all_field_datas
      // updateData.updated_by_admin = 'yes'
      updateData.campaign_id = this.selectedEditCampaignId
      updateData.account_id = this.selectedEditAccountId
      updateData.sales_developer_id = this.user_id
      updateData.account_status = this.selected_account_status
      updateData.account_table_id = this.selected_account_table_id



        if (moduleAccountsManagement.autocomplete_selected) {
            updateData.all_field_datas['_c0271cae_1c5a_4da6_8b37_4a3a19e31f93'] = moduleAccountsManagement.autocomplete_selected.name
          }

          // console.log(updateData.all_field_datas)
          // return false

    


      self.$vs.loading()


      this.$store
        .dispatch('accountsManagement/updateSDQCAccount', updateData)
        .then(res => {
          this.selectedEditCampaignId = null
          this.selectedEditAccountId = null
        

          let response_data = res.data

          if (response_data.status == 'success') {
            this.$vs.notify({
              color: response_data.status,
              title: response_data.title,
              text: response_data.message
            })

            self.$vs.loading.close()
          }

          this.editSDAccountPopUp = false


          this.selected_account_aggrid_node.data = JSON.parse(response_data.data)


          this.$refs.SDQCAccount.gridApi.refreshCells({
            rowNodes: [this.selected_account_aggrid_node],
            force: true
          })

          this.getSDAccountSelectedFields()
        })
        .catch(err => {
          console.log(err)
          if (err.response.status === 401) {
            this.$router.replace('/login')
          }
        })


    },
    updateSDContact () {




      let updateData = {}
      updateData.all_contact_field_datas = this.all_contact_field_datas
      updateData.campaign_id = this.selectedEditCampaignId
      updateData.contact_id = this.selectedEditContactId
      updateData.sales_developer_id = this.user_id
      updateData.contact_status = this.selected_contact_status
      updateData.contact_table_id = this.selected_contact_table_id
      // updateData.updated_by_admin = 'yes'
      updateData.account_id = this.selected_account_id

      let self = this

      

      for (const property in this.checkedFields) {
        if (this.checkedFields[property] == '') {
          this.checkedFields[property] = []
        }


      }
      

      updateData.checkbox_columns = this.checkedFields

      // return false
     self.$vs.loading()
      this.$store
        .dispatch('accountsManagement/updateSDQCContact', updateData)
        .then(res => {
          let response_data = res.data





          if (response_data.status == 'success') {
            this.$vs.notify({
              color: response_data.status,
              title: response_data.title,
              text: response_data.message
            })

            self.$vs.loading.close()

          }




          this.selected_contact_aggrid_node.data = JSON.parse(response_data.data)



          this.$refs.SDQCContact.gridApi.refreshCells({
            rowNodes: [this.selected_contact_aggrid_node],
            force: true
          })

          if (updateData.contact_id != null) {
            this.getContactNotes(updateData.contact_id)
            this.getDialCounts(updateData.contact_id)
          }

          this.selectedEditCampaignId = null
          this.selectedEditContactId = null

          this.editSDContactPopUp = false
      
          this.getSDContactSelectedFields()
        })
        .catch(err => {
          console.error(err)
        }).finally(() => {
              this.$vs.loading.close()
            })  


        self.ddis = []
        self.mobiles = []
        self.social_medias = []
        self.emails = []


    },
    getCountries (inputValue) {
      return this.$store
        .dispatch('accountsManagement/getCountries', inputValue)
        .then(response => {
          let data = response.data
          let mappedArray = []
          for (const property in data) {
            mappedArray.push({
              id: data[property].id,
              name: data[property].name_1
            })
          }
          return mappedArray
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace('/login')
          }
        })
    },
    updateSDAccountForm () {
      this.updateSDAccount()
    },
    updateSDContactForm () {
      this.updateSDContact()
    },
    refreshSDAccount () {
      this.$refs.SDQCAccount.gridApi.setFilterModel(null)
      this.$refs.SDQCAccount.gridApi.onFilterChanged()
      this.selected_filter_account_tag = []

      this.$refs.SDQCAccount.gridApi.refreshClientSideRowModel()
      this.getAccountDataSource()

      // this.$refs.SDQCContact.gridApi.setFilterModel(null);
      // this.$refs.SDQCContact.gridApi.onFilterChanged();
    },
    refreshSDContact () {
      this.$refs.SDQCContact.gridApi.setFilterModel(null)
      this.$refs.SDQCContact.gridApi.onFilterChanged()
      this.selected_filter_contact_tag = []



      // this.$refs.SDQCAccount.gridApi.setFilterModel(null);
      // this.$refs.SDQCAccount.gridApi.onFilterChanged();
    },
    onSDQCAccountFilterModified (event) {
      // this.$refs.SDQCAccount.gridApi.refreshClientSideRowModel()
      // this.getAccountDataSource()

      this.$refs.SDQCContact.gridApi.refreshServerSide({ purge: false })
      // this.getContactDataSource()
    },
    deleteKeys (myObj, array) {
      for (let index = 0; index < array.length; index++) {
        delete myObj[array[index]]
      }
      return myObj
    },
    validateEmailZeroBounce (email) {
      let self = this

      if (email) {
        self.$vs.loading()

        this.$store
          .dispatch('contactsManagement/validateEmailZeroBounce', email)
          .then(res => {
            self.email_validate_status = res.data

            setTimeout(() => self.email_validate_status = null, 3000)

            self.$vs.loading.close()
          })
          .catch(err => {
            console.error(err)
          })
      }
    },
    editSalesDeveloperContact (params) {





this.selected_contact_aggrid_node = params.node

let contact = params.data


let self = this


self.editSDAccountPopUp = false

self.editSDContactPopUp = true
// this.editSelectedAccount = account
let data = {}
data.contact_id = contact.new_contact_id
data.campaign_id = contact.campaign_id
self.selectedEditCampaignId = contact.campaign_id
self.selectedEditContactId = contact.new_contact_id

self.selected_sd_account_id = contact.account_id
self.selected_account_id = contact.account_id

self.selected_contact_status = contact.contact_status
self.selected_contact_table_id = contact.table_id


self.all_contact_field_datas = params.data



Object.keys(self.all_contact_field_datas).forEach(function (key) {







if (typeof self.all_contact_field_datas[key] === 'string' || self.all_contact_field_datas[key] instanceof String) {
  


if (self.all_contact_field_datas[key].startsWith('[') && self.all_contact_field_datas[key] != '[]') {




self.all_contact_field_datas[key] = JSON.parse(self.all_contact_field_datas[key])






}





}


let campaign_data_options = self.all_contact_field_datas['campaign_data_options']

campaign_data_options.forEach(function (ele) {
  if (ele.identifier == 'none_core_field' && ele.type == 'checkbox' && ele.column_id == key) {
   if (self.all_contact_field_datas[key] == null) {
  self.all_contact_field_datas[key] = []
}
  }



  if (ele.identifier == 'none_core_field' && ele.type == 'textarea' && ele.column_id == key  && ele.level == 'contact') {

if(self.all_contact_field_datas[key] == null){
  self.all_contact_field_datas[key] = ''
}


}

})




})













      




  








      





// var array = ["id","acc_id","campaign_id","contact_campaign_id","contact_id","contact_status","contact_id", "contact_status","contact_web"];
// this.editSelectedContact = this.deleteKeys(contact, array);
// console.log("Contact", this.editSelectedContact);
},
    editSalesDeveloperAccount (params) {





      this.selected_account_aggrid_node = params.node

      let account = params.data



      let self = this
      

      self.websites = [
        {
          counter: 0,
          url: null
        }
      ]

      self.showWebsiteExtraField = false

      self.phones = [
        {
          counter: 0,
          phone_no: null
        }
      ]

      self.showPhoneExtraField = false

      self.linkedins = [
        {
          counter: 0,
          url: null
        }
      ]

      self.showLinkedExtraField = false
      self.editSDContactPopUp = false
      self.editSDAccountPopUp = true
      // this.editSelectedAccount = account
      let data = {}
      data.account_id = account.acc_id
      data.campaign_id = account.account_campaign_id
      self.selectedEditCampaignId = account.account_campaign_id
      self.selectedEditAccountId = account.acc_id
      self.selected_account_status = account.account_status
      self.selected_account_table_id = account.table_id

      self.all_field_datas = params.data







      Object.keys(self.all_field_datas).forEach(function (key) {


        if (typeof self.all_field_datas[key] === 'string' || self.all_field_datas[key] instanceof String) {






if (self.all_field_datas[key].startsWith('[') && self.all_field_datas[key] != '[]') {


  

  self.all_field_datas[key] = JSON.parse(self.all_field_datas[key])






}





}


let campaign_data_options = self.all_field_datas['campaign_data_options']

campaign_data_options.forEach(function (ele) {
  if (ele.identifier == 'none_core_field' && ele.type == 'checkbox' && ele.column_id == key) {
   if (self.all_field_datas[key] == null) {
  self.all_field_datas[key] = []
}







  }


  if (ele.identifier == 'none_core_field' && ele.type == 'textarea' && ele.column_id == key  && ele.level == 'account') {

if(self.all_field_datas[key] == null){
  self.all_field_datas[key] = ''
}


}

 





})



      })


 

        
      

      





           




                  




              

             



            



                  




  


    
    },
    showSalesDeveloperAuditTrial (params) {
      this.selected_contact_aggrid_node = params.node

      let contact = params.data



      let self = this

      self.AuditTrialPopupActive = true

      self.auditTrialSelectedContact = contact

      self.auditTrialWithDial = false

      self.showContactsFieldsWithContactID(contact.new_contact_id, contact.account_id)

      // this.editSelectedAccount = account
    },

    showContactsWithAccountID (account_id) {
      if (account_id == null) {
        this.$refs.SDQCAccount.gridApi.clearFocusedCell()
      }

      let selected = this.$refs.SDQCContact.gridApi.getSelectedNodes()
      _.each(selected, function (node) {
        node.hightlight = null
        node.setSelected(false)
      })

      this.getAccountNotes(account_id)

      this.selected_account_id = account_id
      this.$refs.SDQCContact.gridApi.refreshServerSide({ purge: true })
      // this.getContactDataSource()
      this.getSDAccountSelectedFields()
      this.selected_contact_id = null
    },
    showContactsFieldsWithContactID (contact_id,account_id) {
      let self = this






      self.selected_contact_id = contact_id
    
      if (contact_id == null) {

        self.$refs.SDQCContact.gridApi.clearFocusedCell()


        let selected = self.$refs.SDQCAccount.gridApi.getSelectedNodes()
        _.each(selected, function (node) {
          node.highlighted = '0'
          node.setSelected(false)
        })

        self.contactsAuditTrials = []
        self.accountNotes = null
        self.dial_counts = 0
      } else {


        self.$refs.SDQCAccount.gridApi.forEachNode(function(node) { 
          let node_data = node.data

       


          if(node_data.acc_id == account_id){

          
            node.setSelected(true)
            node.hightlight = '1'
          }
    });



          var focusedCell = self.$refs.SDQCAccount.gridApi.getSelectedNodes()
          let selected_row_index = focusedCell[0].rowIndex

          let page_index = Math.floor(selected_row_index / self.$refs.SDQCAccount.gridApi.paginationGetPageSize())

          self.$refs.SDQCAccount.gridApi.paginationGoToPage(page_index)

        self.getAuditTrails(contact_id)
        self.getContactNotes(contact_id)
        self.getDialCounts(contact_id)

        let selected = self.$refs.SDQCAccount.gridApi.getSelectedNodes()
        _.each(selected, function (node) {
          node.highlighted = '1'
          node.setSelected(true)
        })




    self.selected_account_id = account_id
    self.getSDAccountSelectedFields()

    self.getSDContactSelectedFields()

      }
    },

    addFields () {
      this.$router.push({ path: `/fields/campaign-field/add` })
    },
    onPaginationChangeContact(data){
// ddddd

//       let self = this

//       if (data.keepRenderedRows == true){

//         let displayed_contact_nodes =   self.$refs.SDQCContact.gridApi.getRenderedNodes().map((row) => row.data.account_id);

// console.log(displayed_contact_nodes.every( (val, i, arr) => val === arr[0] ))

// if(displayed_contact_nodes.every( (val, i, arr) => val === arr[0] ) == true){
//   console.log("All Same")
// }else{
//   console.log("All Not Same")

// self.selected_account_id = null

// let selected = self.$refs.SDQCAccount.gridApi.getSelectedNodes()
// _.each(selected, function (node) {
// node.highlighted = '0'
// node.setSelected(false)
// })
// self.$refs.SDQCContact.gridApi.clearFocusedCell()





// }





// console.log(displayed_contact_nodes)

//       }

   


     






    },
    getAccountDataSource() {
      var self = this;
      let data = {};
      data.campaign_id = self.$route.params.campaignId

      self.$store
        .dispatch("accountsManagement/fetchAllSDQCAccountsForClientSide", data)
        .then(function(response) {
          let response_data = JSON.parse(response.data);

          




         

          self.accountRecords = response_data;


        







          

          // self.getSDViewLists()
        })
        .catch(err => {
          console.error(err);
        });
    },


    getContactDataSource () {
      var self = this
      this.contactDataSource = {
        getRows (params) {
          if (self.selected_filter_contact_tag.length != 0) {
            params.request.selected_filter_contact_tag =
              self.selected_filter_contact_tag
          }

          self.contactParamsRequest = params.request
          params.request.campaignId = self.$route.params.campaignId
          // params.request.userId = self.sales_developer_id
          params.request.campaignName = atob(self.$route.params.campaignName)
          params.request.selected_account_id = self.selected_account_id
          params.request.all_sales_developer = 'Yes'
          


          self.$store
            .dispatch('accountsManagement/fetchAllSDQCContacts', params.request)
            .then(function (response) {
              let response_data = response.rows



              response_data.forEach(function (ele) {


if(ele._2619e88b_cc7c_48bd_8934_de7113d6b849){


  if (ele._2619e88b_cc7c_48bd_8934_de7113d6b849.length == 0) {
  ele._053ef7ea_b2ed_4110_8318_76d7e8268526 = "";

} else if (ele._2619e88b_cc7c_48bd_8934_de7113d6b849.length > 1) {
  ele._053ef7ea_b2ed_4110_8318_76d7e8268526 = ele._2619e88b_cc7c_48bd_8934_de7113d6b849[0].summary;

} else {
  ele._053ef7ea_b2ed_4110_8318_76d7e8268526 = ele._2619e88b_cc7c_48bd_8934_de7113d6b849[0].summary;

}
}



});

       



                if (response_data) {
                  if (response_data.length > 0) {
                    self.$refs.SDQCContact.gridApi.hideOverlay()
                    params.success({ rowData: response.rows , rowCount: response.lastRow })
                  } else {
                    self.$refs.SDQCContact.gridApi.showNoRowsOverlay()
                    params.success({ rowData: [] , rowCount: response.lastRow})
                  }
                } else {
                  params.fail()
                }
            })
            .catch(err => {
              console.error(err)
            })

          // self.getSDViewLists()
        }
      }
    },
    removeSelectedNewMobile (mobile) {
      this.mobiles = this.mobiles.filter(item => {
        return item.counter != mobile.counter
      })
    },
    removeSelectedMobile (mobile) {
      this.core_field_datas.mobile = this.core_field_datas.mobile.filter(
        item => {
          return item.mobile != mobile
        }
      )
    },
    addMobile () {
      if (this.mobiles.length == 1 && !this.showMobileExtraField) {
        this.showMobileExtraField = true
      } else if (this.mobiles.length == 1 && this.showMobileExtraField) {
        this.mobiles.push({
          mobile: null,
          is_primary: null,
          mobile_phone_code: null,
          counter: ++this.mobile_counter
        })
      } else {
        this.mobiles.push({
          mobile: null,
          is_primary: null,
          mobile_phone_code: null,
          counter: ++this.mobile_counter
        })
      }
    },
    removeSelectedNewSocial_media (social_media) {
      this.social_medias = this.social_medias.filter(item => {
        return item.counter != social_media.counter
      })
    },
    removeSelectedSocial_media (social_media) {
      this.core_field_datas.social_media =
        this.core_field_datas.social_media.filter(item => {
          return item.social_media != social_media
        })
    },
    addSocial_media () {
      if (this.social_medias.length == 1 && !this.showSocial_mediaExtraField) {
        this.showSocial_mediaExtraField = true
      } else if (
        this.social_medias.length == 1 &&
        this.showSocial_mediaExtraField
      ) {
        this.social_medias.push({
          url: null,
          summary: null,
          is_primary: null,
          counter: ++this.social_media_counter
        })
      } else {
        this.social_medias.push({
          url: null,
          summary: null,
          is_primary: null,
          counter: ++this.social_media_counter
        })
      }
    },
    getCampaignDescription () {
      let self = this
      self.$store
        .dispatch(
          'campaignsManagement/fetchCampaign',
          self.$route.params.campaignId
        )
        .then(res => {
          self.campaignDescription = res.data
        })
        .catch(err => {
          console.log(err)
        })
    },
    getSDAccountColumns () {
      let self = this
      self.$store
        .dispatch(
          'campaignsManagement/getAllAccountSelectedCampaignColumns',
          self.$route.params.campaignId
        )
        .then(res => {

          let selected_columns = JSON.parse(res.data);



  selected_columns = selected_columns.filter(function(ele) {
    return ele.identifier != 'phone_code' && ele.identifier != 'phone_type' && ele.identifier != 'account_status' && ele.identifier != 'account_sub_status' && ele.identifier != 'account_status_notes'
  });


  var index = 1;
selected_columns.forEach(function(ele) {
  ele.id = ele.uuid

  ele.headerName = ele.name;

  ele.field = '_' + ele.id.replaceAll("-", "_");

  if (ele.type == "textarea") {
                ele.cellRenderer =  function(params) {
                            return params.value ? params.value : '';
                        }
              }


    if (ele.type == "date" || ele.type == "datetime") {
      ele.filter = "agDateColumnFilter";
      ele.filterParams = filterDateParams

    } else if (ele.type == "number") {
      ele.filter = "agNumberColumnFilter";
      ele.filterParams = {
    buttons: ["apply", "reset"],
    maxNumConditions: 4
  };
    } else {
      ele.filter = "agTextColumnFilter";
      ele.filterParams = {
    buttons: ["apply", "reset"],
    maxNumConditions: 4
  };
    }

    ele.valueFormatter = AccountsMultipleValueFormatter




  ele.width = 170;
 
});

this.accountColumnDefs = selected_columns


          let actions = {
            headerName: 'Actions',
            sortable: false,

            field: 'transactions',
            cellRenderer: 'CellRendererActions',
            suppressHeaderMenuButton: true,
            pinned: true,
            width: 110
          }

          this.accountColumnDefs.push(actions)

          let account_status = {
            column_name: "account_status",
            field: "account_status",
            filter: "agTextColumnFilter",
            filterParams: {
              buttons: ["apply", "reset"],
              maxNumConditions: 4
            },
            headerName: "Account Status"
          };

          this.accountColumnDefs.push(account_status);


           let account_sub_status = {
            column_name: "account_sub_status",
            field: "account_sub_status",
            filter: "agTextColumnFilter",
            filterParams: {
              buttons: ["apply", "reset"],
              maxNumConditions: 4
            },
            headerName: "Account Sub Status"
          };

          this.accountColumnDefs.push(account_sub_status);


          let account_status_notes = {
            column_name: "account_status_notes",
            field: "account_status_notes",
            filter: "agTextColumnFilter",
            filterParams: {
              buttons: ["apply", "reset"],
              maxNumConditions: 4
            },
            headerName: "Account Status Notes"
          };

          this.accountColumnDefs.push(account_status_notes);

        
          let tag = {
            column_name: "tag",
            field: "tag",
            filter: "agSetColumnFilter",
            filterParams: {
              buttons: ["apply", "reset"],
              maxNumConditions: 4
            },
            headerName: "Tag"
          };

          this.accountColumnDefs.push(tag);

    
        })
        .catch(err => {
          console.log(err)
        })
    },
    getSDContactsColumns () {
      let self = this
      self.$store
        .dispatch(
          'campaignsManagement/getAllContactSelectedCampaignColumns',
          self.$route.params.campaignId
        )
        .then(res => {

          let contact_columns = JSON.parse(res.data);


          
          


          contact_columns = contact_columns.filter(function(ele) {
              return ele.identifier != 'mobile_phone_code' && ele.identifier != 'ddi_phone_code' && ele.identifier != 'contact_status' && ele.identifier != 'contact_sub_status' && ele.identifier != 'contact_status_notes' && ele.identifier != 'grade'
            });


            


            var index = 1;
            contact_columns.forEach(function(ele) {

              


              ele.id = ele.uuid


             

          

          
              ele.headerName = ele.name;


              ele.field = '_' + ele.id.replaceAll("-", "_");


              if (ele.type == "textarea") {
                ele.cellRenderer =  function(params) {
                            return params.value ? params.value : '';
                        }
              }




                if (ele.type == "date" || ele.type == "datetime") {
                  ele.filter = "agDateColumnFilter";
                } else if (ele.type == "number") {
                  ele.filter = "agNumberColumnFilter";
                } else {
                  ele.filter = "agTextColumnFilter";
                }

                // if (ele.identifier == 'contact_social_media_summary'){
                //   ele.headerName = 'Social Media Summary'
                // }


              ele.width = 170;
              ele.filterParams = {
                buttons: ["apply", "reset"],
                maxNumConditions: 4
              };

              ele.valueFormatter = ContactsMultipleValueFormatter





            });

          let all_dial_columns = ['S', 'DDI', 'Cell', 'Others']
          self.acc_col.forEach(function (ele) {
            if (ele.field == 'site_switchboard_phone_code') {
              all_dial_columns.push('SS')
            }
          })
          contact_columns.push({
            headerName: 'Dial',
            sortable: false,
            field: 'dial',
            width: 200,
            filter: 'agSetColumnFilter',
            filterParams: {
            values: all_dial_columns,
            suppressSelectAll : true,
            defaultToNothingSelected : true
        },
            cellRenderer: 'CellRendererButtons'
          })


          contact_columns.push({
            headerName: 'Grade',
            field: 'grade',
            width: 100,
            filter : 'agNumberColumnFilter',
            filterParams : {
                buttons: ["apply", "reset"],
                maxNumConditions: 4
              }
           
          })

          contact_columns.push({
            headerName: 'Audit',
            field: 'audit_trial',
            width: 60,
            pinned: true,

            cellRenderer: params => {
              let eIconGui = document.createElement('span')
              return (eIconGui.innerHTML =
                '<em class="material-icons">call_split</em>')
            }
          })

          var sorted = _.sortBy(contact_columns, function (item) {
            return item.field === 'dial' ? 0 : 1
          })

          let actions = {
            headerName: 'Actions',
            sortable: false,

            field: 'transactions',
            cellRenderer: 'CellRendererActions',
            suppressHeaderMenuButton: true,
            pinned: true,
            width: 110
          }
          

          this.contactsColumnDefs = sorted


          let sales_developer = {
            column_name: "sales_developer",
            field: "sales_developer",
            filter: "agTextColumnFilter",
            filterParams: {
              buttons: ["apply", "reset"],
              maxNumConditions: 4
            },
            headerName: "Sales Developer"
          };

          this.contactsColumnDefs.push(sales_developer);


          let company_name = {
            column_name: "_ec41e532_632d_4323_8071_f60b4543a68a",
            field: "_ec41e532_632d_4323_8071_f60b4543a68a",
            filter: "agTextColumnFilter",
            filterParams: {
              buttons: ["apply", "reset"],
              maxNumConditions: 4
            },
            headerName: "Company Name"
          };

          this.contactsColumnDefs.push(company_name);


          let contact_status = {
            column_name: "contact_status",
            field: "contact_status",
            filter: "agTextColumnFilter",
            filterParams: {
              buttons: ["apply", "reset"],
              maxNumConditions: 4
            },
            headerName: "Contact Status"
          };

          this.contactsColumnDefs.push(contact_status);

          let contact_sub_status = {
            column_name: "contact_sub_status",
            field: "contact_sub_status",
            filter: "agTextColumnFilter",
            filterParams: {
              buttons: ["apply", "reset"],
              maxNumConditions: 4
            },
            headerName: "Contact Sub Status"
          };

          this.contactsColumnDefs.push(contact_sub_status);

          let contact_status_notes = {
            column_name: "contact_status_notes",
            field: "contact_status_notes",
            filter: "agTextColumnFilter",
            filterParams: {
              buttons: ["apply", "reset"],
              maxNumConditions: 4
            },
            headerName: "Contact Status Notes"
          };

          this.contactsColumnDefs.push(contact_status_notes);


          this.contactsColumnDefs.push(actions)








        })
        .catch(err => {
          console.log(err)
        })
    },
    getSDAccountSelectedFields() {
      var self = this;
      self.getSDAccountSelectedFieldRecords = []

      let data = {};
      data.campaign_id =  self.$route.params.campaignId
      data.account_id = self.selected_account_id
      self.$store
        .dispatch("accountsManagement/fetchAllSDQCAccountFieldsForClientSide", data)
        .then(function(response) {
          let result = JSON.parse(response.data)


              result.forEach(function (ele) {
                let ele_column = Object.keys(ele)
                ele.column = ele_column
                let ele_value = Object.values(ele)[0]
                if (
                  ele_value != null &&
                  ele_value != '[None]' &&
                  ele_value != 'None'
                ) {
                  ele.value = ele_value
                }




                return ele
              })

              result = result.filter(ele => ele.value != null && ele.value != '')


          self.getSDAccountSelectedFieldRecords = result;


        })
        .catch(err => {
          console.error(err);
        });


    },
   
    getPhoneCodes (inputValue) {
      return this.$store
        .dispatch('accountsManagement/getPhoneCodes', inputValue)
        .then(response => {
          let data = response.data
          let mappedArray = []
          for (const property in data) {
            if (data[property].phone_code) {
              mappedArray.push({
                id: data[property].id,
                name: data[property].phone_code + ' - ' + data[property].name_1
              })
            }
          }
          return mappedArray
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace('/login')
          }
        })
    },
    getAllPhoneCodes () {
      let self = this
      this.$store
        .dispatch('accountsManagement/getAllPhoneCodes')
        .then(response => {
          self.all_phone_codes = response.data
          self.all_countries = response.data
          self.all_phone_codes.forEach(function(ele){
            if(ele.phone_code){
              ele.name_with_code = ele.phone_code + ' - ' + ele.name_1
            }
            return ele
          })
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace('/login')
          }
        })
    },
    getSDContactSelectedFields() {
      var self = this;
      self.getSDContactSelectedFieldRecords = []

      let data = {};
      data.campaign_id =  self.$route.params.campaignId


      if (typeof(self.selected_contact_id) == 'undefined' || self.selected_contact_id == null){
        self.selected_contact_id = self.selected_contact_aggrid_node.data.new_contact_id
       }

      data.contact_id = self.selected_contact_id
      self.$store
        .dispatch("accountsManagement/fetchAllSDQCContactFieldsForClientSide", data)
        .then(function(response) {
          let result = JSON.parse(response.data)

              result.forEach(function (ele) {
                let ele_column = Object.keys(ele)
                ele.column = ele_column
                let ele_value = Object.values(ele)[0]
                if (
                  ele_value != null &&
                  ele_value != '[None]' &&
                  ele_value != 'None'
                ) {
                  ele.value = ele_value
                }
                return ele
              })
              



              

              result = result.filter(ele => ele.value != null && ele.value != '')




          self.getSDContactSelectedFieldRecords = result;




        })
        .catch(err => {
          console.error(err);
        });


    },

    addMobile (key) {

let self = this

Object.keys(self.all_contact_field_datas).forEach(function (k) {

  if (k == key){

    if (self.all_contact_field_datas[k] == null){
      self.all_contact_field_datas[k] = []
    }
    
    self.all_contact_field_datas[k].push({mobile_phone_code : null , mobile : null})

  }



})


},
    removeSelectedMobile (key,web) {
      let self = this

      Object.keys(self.all_contact_field_datas).forEach(function (k) {

        if (k == key){
          

          self.all_contact_field_datas[k] = self.all_contact_field_datas[k].filter(item => {

        return item != web
      })

        }



})
    },
    addDDI (key) {

let self = this

Object.keys(self.all_contact_field_datas).forEach(function (k) {

  if (k == key){

    if (self.all_contact_field_datas[k] == null){
      self.all_contact_field_datas[k] = []
    }
    
    self.all_contact_field_datas[k].push({ddi_phone_code : null , ddi : null , is_primary : false})

  }



})


},
    removeSelectedDDI (key,web) {
      let self = this

      Object.keys(self.all_contact_field_datas).forEach(function (k) {

        if (k == key){
          

          self.all_contact_field_datas[k] = self.all_contact_field_datas[k].filter(item => {

        return item != web
      })

        }



})
    },



    addPhone (key) {





let self = this

Object.keys(self.all_field_datas).forEach(function (k) {

  if (k == key){

    if (self.all_field_datas[k] == null){
      self.all_field_datas[k] = []
    }
    
    self.all_field_datas[k].push({phone_code : null , phone_no : null , phone_type : null})

  }



})


},
    removeSelectedPhone (key,web) {
      let self = this

      Object.keys(self.all_field_datas).forEach(function (k) {

        if (k == key){
          

          self.all_field_datas[k] = self.all_field_datas[k].filter(item => {

        return item != web
      })

        }



})
    },
    removeSelectedWeb (key,web) {
      let self = this

      Object.keys(self.all_field_datas).forEach(function (k) {

        if (k == key){
          

          self.all_field_datas[k] = self.all_field_datas[k].filter(item => {

        return item != web
      })

        }



})
    },

    addWebsite (key) {





      let self = this

      Object.keys(self.all_field_datas).forEach(function (k) {

        if (k == key){

          if (self.all_field_datas[k] == null){
            self.all_field_datas[k] = []
          }
          
          self.all_field_datas[k].push({url : null})

        }



})


    },
    removeSelectedSocialMedia (key,social_media) {
  let self = this

  Object.keys(self.all_contact_field_datas).forEach(function (k) {

    if (k == key){
      

      self.all_contact_field_datas[k] = self.all_contact_field_datas[k].filter(item => {

    return item != social_media
  })

    }



})
},

addSocialMedia (key) {





  let self = this

  Object.keys(self.all_contact_field_datas).forEach(function (k) {

    if (k == key){

      if (self.all_contact_field_datas[k] == null){
        self.all_contact_field_datas[k] = []
      }


      
      self.all_contact_field_datas[k].push({social_media : null,summary : null})

    }



})


},
    removeSelectedEmail (key,email) {
  let self = this

  Object.keys(self.all_contact_field_datas).forEach(function (k) {

    if (k == key){
      

      self.all_contact_field_datas[k] = self.all_contact_field_datas[k].filter(item => {

    return item != email
  })

    }



})
},

addEmail (key) {





  let self = this

  Object.keys(self.all_contact_field_datas).forEach(function (k) {

    if (k == key){

      if (self.all_contact_field_datas[k] == null){
        self.all_contact_field_datas[k] = []
      }


      
      self.all_contact_field_datas[k].push({email : null})

    }



})


},
    removeSelectedLinkedin (key,linkedin) {
  let self = this

  Object.keys(self.all_field_datas).forEach(function (k) {

    if (k == key){
      

      self.all_field_datas[k] = self.all_field_datas[k].filter(item => {

    return item != linkedin
  })

    }



})
},

addLinkedIn (key) {





let self = this

Object.keys(self.all_field_datas).forEach(function (k) {

  if (k == key){

    if (self.all_field_datas[k] == null){
      self.all_field_datas[k] = []
    }
    
    self.all_field_datas[k].push({url : null})

  }



})


},
    removeSelectedNewDdi (ddi) {
      this.ddis = this.ddis.filter(item => {
        return item.counter != ddi.counter
      })
    },
    removeSelectedDdi (ddi) {
      this.core_field_datas.ddi = this.core_field_datas.ddi.filter(item => {
        return item.ddi != ddi
      })
    },
  

    goBack: function () {
      this.$router.go(-1)
    },
    getRoles () {
      this.$store
        .dispatch('contactsManagement/getRoles')
        .then(res => {
          this.roles = res.data
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace('/login')
          }
        })
    },
    fetchCampaignDetails () {
      this.$store
        .dispatch('campaignsManagement/fetchCampaign', this.campaignId)
        .then(res => {
          this.selected_campaign = res.data
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.selected_campaign = true
            return
          }
          console.error(err)
        })
    },
    getCampaignAccountsTotalRows() {
      

      let self = this
      let data = {}
      data.campaignId = this.$route.params.campaignId
      data.sales_developer_id = 0


      axios
        .post(
          this.$base_url +
            '/api/accounts/get_campaign_accounts_total_rows',
          data
        )
        .then(response => {
          self.no_of_campaign_accounts = response.data

       


          
        
        })
        .catch(error => {
          console.log(error)
        })
    },
    getCampaignContactsTotalRows() {
      

      let self = this
      let data = {}
      data.campaignId = this.$route.params.campaignId
      data.sales_developer_id = 0

      data.account_ids = []




      axios
        .post(
          this.$base_url +
            '/api/accounts/get_campaign_contacts_total_rows',
          data
        )
        .then(response => {
          self.no_of_campaign_contacts = response.data


          
        
        })
        .catch(error => {
          console.log(error)
        })
    },
    getPhoneTypes () {
      this.$store
        .dispatch('accountsManagement/getPhoneTypes')
        .then(res => {
          this.phoneTypes = res.data
          this.phoneTypes = this.phoneTypes.filter(
            item =>
              item.slug != 'head_office_switchboard' &&
              item.slug != 'site_switchboard'
          )
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace('/login')
          }
        })
    },

  },
  beforeMount () {
      this.getSDCampaignViewSettings()
      this.getSDAccountColumns()
      this.getSDContactsColumns()
      this.getAccountDataSource()
      this.getContactDataSource()
     
  },
  mounted () {
    this.getCampaignAccountsTotalRows();
    this.getCampaignContactsTotalRows();

      this.getPhoneTypes()
      this.getDialAction()
      this.getCampaignDescription()
      this.getSeniority()
      this.getRoles()
      this.fetchAllActionTypes()
      this.fetchCampaignAssociatedClientContact()
      this.getAllRoles();
    this.getAllSeniority();
    this.getAllPhoneCodes()
    this.getAllSicCodes()
    this.getAllVerticals()
    this.getAllCurrencyCodes()


 

      var self = this

      setTimeout(function () {

if (self.$route.params.forename != undefined) {
 
  self.selected_view_for_sd = null


var ForenameFilterComponent = self.$refs.SDQCContact.gridApi.getFilterInstance("_78540c9c_ce81_4ec0_8320_31838956392a");

ForenameFilterComponent.setModel({
type: "equal",
filter: atob(self.$route.params.forename)
});

ForenameFilterComponent.applyModel();


var SurameFilterComponent = self.$refs.SDQCContact.gridApi.getFilterInstance("_755c8e1e_1725_4653_93f6_b8a888f4a423");

SurameFilterComponent.setModel({
type: "equal",
filter: atob(self.$route.params.surname)
});

SurameFilterComponent.applyModel();

var JobTitleFilterComponent = self.$refs.SDQCContact.gridApi.getFilterInstance("_bd654e2e_a6c3_426a_8486_30e753088090");

JobTitleFilterComponent.setModel({
type: "equal",
filter: atob(self.$route.params.job_title)
});

JobTitleFilterComponent.applyModel();


self.$refs.SDQCContact.gridApi.onFilterChanged()

}
else{
  self.getSDViewLists()
}



}, 200)


  },
  created () {
    var self = this
    defineAbilitiesFor().then(function (data) {
      self.abilities = data
    })
    self.sales_developer_id = self.$route.params.sd_user_id
    let userInfo = JSON.parse(localStorage.getItem('userInfo'))
    this.user_id = userInfo['uid']

    console.log("USER INFO" , userInfo)
    this.user_role_id = userInfo['roleId'] // userInfo['role_id']
    // this.viewing_as_full_name = atob(self.$route.params.sd_user_full_name)

    if (!moduleAccountsManagement.isRegistered) {
      defineAbilitiesFor().then(function (data) {
        self.abilities = data
      })
      this.$store.registerModule('accountsManagement', moduleAccountsManagement)
      moduleAccountsManagement.isRegistered = true
    }

    if (!moduleCampaignsManagement.isRegistered) {
      this.$store.registerModule(
        'campaignsManagement',
        moduleCampaignsManagement
      )
      moduleCampaignsManagement.isRegistered = true
    }

    if (!moduleElomarkUserManagement.isRegistered) {
      this.$store.registerModule(
        'elomarkUsersManagement',
        moduleElomarkUserManagement
      )
      moduleElomarkUserManagement.isRegistered = true
    }

    if (!moduleOutcomeManagement.isRegistered) {
      this.$store.registerModule('OutcomesManagement', moduleOutcomeManagement)
      moduleOutcomeManagement.isRegistered = true
    }

    if (!moduleContactsManagement.isRegistered) {
      this.$store.registerModule('contactsManagement', moduleContactsManagement)
      moduleContactsManagement.isRegistered = true
    }

    if (!moduleAuditTrialManagement.isRegistered) {
      this.$store.registerModule(
        'AuditTrialsManagement',
        moduleAuditTrialManagement
      )
      moduleAuditTrialManagement.isRegistered = true
    }

    if (!moduleGradeManagement.isRegistered) {
      this.$store.registerModule('GradesManagement', moduleGradeManagement)
      moduleGradeManagement.isRegistered = true
    }

    if (!moduleTagManagement.isRegistered) {
      this.$store.registerModule('TagsManagement', moduleTagManagement)
      moduleTagManagement.isRegistered = true
    }

     if (!moduleSDSubStatusManagement.isRegistered) {
      this.$store.registerModule("SDSubStatusManagement", moduleSDSubStatusManagement);
      moduleSDSubStatusManagement.isRegistered = true;
    }

    this.campaignId = this.$route.params.campaignId

  }
}
</script>
<!-- <style src='vue-dialog-drag/dist/vue-dialog-drag.css'></style> -->
<style scoped>
.audit_trial_style {
  height: 600px;
  overflow-y: scroll;
}

.vs-input-class{
  width: 100%;
  border: 1px solid rgba(0, 0, 0, 0.2);
  font-size: 1rem;
  height: 38px;
  padding-left: 10px;
  padding-right: -10px;
  border-radius: 4px;
  background: transparent;
  transition: all .2s ease;


}

.removeButton {
  cursor: pointer;
}

.vs-table--tbody-table tr {
  -webkit-transition: none;
  transition: none;
  background: #fff;
}

.searchbox {
  margin-left: 5px;
  width: 600px;
}

.phone_code {
  margin-left: 5px;
  width: 220px;
}

.filter {
  width: 300px;
}

.pointer {
  cursor: pointer;
}

.item.expanded {
  background-color: white !important;
  color: black !important;
}

.pointer {
  cursor: pointer;
}

.address_th {
  padding: 30px;
}

.address_td {
  padding: 30px;
  font-weight: 200;
}

.agrid-scroll {
  overflow-x: hidden;
  overflow-y: scroll;
  height: 572px;
  padding-right: 15px;
}

.td .vs-table--td {
  width: 100%;
}

.ql-class {
  width: 580px;
}

.vertical-align {
  font-size: 10px;
  display: flex;
  justify-content: center;
  /* align horizontal */
  align-items: center;
  /* align vertical */
  /* width: 800px; */
}

.tag-filter {
  cursor: pointer;
}

.blur-content {
  width: 100%;
  height: 100%;
  background: rgba(247, 244, 244, 0.7);
  top: 0;
  left: 0;
  z-index: 2;
  pointer-events: none;
  opacity: 0.5;
}

.text_box {
  display: none;
}

/* .autocom {
  padding: 0.7rem !important;
  border: 1px solid rgba(0, 0, 0, 0.2);
  font-size: 1rem !important;
  width: 80%;

} */

/* .auto_search_container {
  justify-content: center;
  align-items: center;
  width: 200px;
  margin-top: 100px;
  position: relative;
  input {
    width: 100%;
    border: none;
    height: 38px;
    padding-left: 10px;
    padding-right: -10px;
    box-shadow: inset 0 0 0 1px #b2b2b2;
    border-radius: 4px;
    background: transparent;
    transition: all .2s ease;
    &:focus {
      outline: none;
      box-shadow: inset 0 0 0 2px #ffb300;
    }
  }
  .results {
    position: absolute;
    width: 100%;
    background: #fff;  box-shadow: 0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23);
    .result {
      padding:  20px 0.75rem;
      &:hover {
        background: #efefef;
      }
    }
  }
} */
</style>
